var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147,
    height: 88.254,
    viewBox: "0 0 157 128.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-39.118 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    transform: "translate(39.118 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M988.679,776.04l-19.514,6.454,3.918,3.265h0L956.2,803.433l-14.8-12.707L882.32,839.133l.52.008h14.717l43.7-35.8,15.6,13.4,23.667-24.776h0l4.228,3.524Z",
    transform: "translate(-831.679 -716.017)",
    fill: "#c0d8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M289.969,1160.077l-4.589,30.5-40.666-6.119h0l-17.134-2.578,4.59-30.5,31.992,4.813Z",
    transform: "translate(-227.58 -1062.326)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M322.615,1208.237l-3.563,23.681L267.1,1224.1l3.563-23.681Zm-3.847,20.667,2.687-17.859a2.22,2.22,0,0,0-1.865-2.525l-46.078-6.933a2.259,2.259,0,0,0-2.573,1.895l-2.676,17.79a2.243,2.243,0,0,0,1.883,2.552l46.109,6.938a2.208,2.208,0,0,0,2.513-1.857Z",
    transform: "translate(-264.043 -1107.573)",
    fill: "#c0d8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M548.148,1333.541a6.443,6.443,0,1,1,7.33-5.414A6.443,6.443,0,0,1,548.148,1333.541Z",
    transform: "translate(-518.292 -1218.574)",
    fill: "#c0d8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M361.435,718.811l-24.192,19.138L311.73,705.7h0l-10.75-13.59,24.192-19.136,20.072,25.373Z",
    transform: "translate(-295.303 -620.919)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M407.965,767.914l-18.781,14.857-32.594-41.2,18.782-14.857Zm-16.93,12.462,14.164-11.2a2.22,2.22,0,0,0,.364-3.118l-28.909-36.547a2.26,2.26,0,0,0-3.171-.37l-14.11,11.16a2.243,2.243,0,0,0-.367,3.148l28.927,36.57a2.208,2.208,0,0,0,3.1.362Z",
    transform: "translate(-346.612 -670.502)",
    fill: "#c0d8fb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1415",
    "data-name": "Ellipse 1415",
    cx: 6.443,
    cy: 6.443,
    r: 6.443,
    transform: "translate(26.915 81.696) rotate(-28.79)",
    fill: "#c0d8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M1757.88,820.7a.739.739,0,0,1,.092-.145h0a.751.751,0,0,1,.089-.09l.135-.136.035.026c.688-.337,2.109.02,3.545.958,1.737,1.134,2.852,2.695,2.53,3.525l.049.036-.192.193-.029.029-.005.005h0a.8.8,0,0,1-.167.116h0c-.679.356-2.115,0-3.567-.947C1758.622,823.12,1757.5,821.522,1757.88,820.7Z",
    transform: "translate(-1639.449 -756.793)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M1764.444,818.641c-1.769-1.156-3.513-1.429-3.9-.613s.742,2.416,2.51,3.57,3.514,1.429,3.9.613S1766.213,819.8,1764.444,818.641Z",
    transform: "translate(-1641.91 -754.324)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M1768.028,824.915a6.968,6.968,0,0,1-1.8-1.645c-.428-.59-.575-1.107-.416-1.454a.678.678,0,0,1,.455-.364,4.264,4.264,0,0,1,2.947.917h0a6.968,6.968,0,0,1,1.8,1.646c.428.59.575,1.106.416,1.454a.674.674,0,0,1-.455.363,1.414,1.414,0,0,1-.387.049A5.2,5.2,0,0,1,1768.028,824.915Zm-1.722-3.337a.55.55,0,0,0-.373.292c-.137.3.01.781.4,1.323a6.838,6.838,0,0,0,1.763,1.613,5.13,5.13,0,0,0,2.49.944,1.275,1.275,0,0,0,.35-.044.55.55,0,0,0,.373-.292c.137-.3-.01-.781-.4-1.324a6.835,6.835,0,0,0-1.762-1.613,5.133,5.133,0,0,0-2.49-.944A1.271,1.271,0,0,0,1766.306,821.578Z",
    transform: "translate(-1646.781 -757.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M1896.288,285.7a.491.491,0,0,1,.065-.1h0a.467.467,0,0,1,.063-.064l.095-.1.026.019a3.091,3.091,0,0,1,2.517.681c1.233.8,2.024,1.913,1.8,2.5l.035.026-.137.136-.021.021v0h0a.554.554,0,0,1-.119.082h0a3.049,3.049,0,0,1-2.532-.672C1896.813,287.419,1896.016,286.285,1896.288,285.7Z",
    transform: "translate(-1767.171 -263.298)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M1900.941,284.241c-1.256-.82-2.494-1.015-2.766-.435s.527,1.715,1.779,2.535,2.494,1.015,2.766.435S1902.2,285.06,1900.941,284.241Z",
    transform: "translate(-1768.912 -261.547)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M1903.488,288.7a4.933,4.933,0,0,1-1.275-1.169c-.3-.418-.409-.785-.3-1.032a.477.477,0,0,1,.323-.258,3.01,3.01,0,0,1,2.088.65h0a4.934,4.934,0,0,1,1.275,1.168c.3.419.409.786.3,1.033a.476.476,0,0,1-.323.258,1.019,1.019,0,0,1-.277.035A3.693,3.693,0,0,1,1903.488,288.7Zm-1.219-2.37a.392.392,0,0,0-.265.207c-.1.213.007.555.286.94a4.852,4.852,0,0,0,1.251,1.146,3.651,3.651,0,0,0,1.768.671.905.905,0,0,0,.248-.031.394.394,0,0,0,.265-.208c.1-.212-.007-.555-.286-.94a4.875,4.875,0,0,0-1.256-1.145,3.648,3.648,0,0,0-1.768-.67A.892.892,0,0,0,1902.269,286.329Z",
    transform: "translate(-1772.373 -264.069)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1898.726,710.98a.5.5,0,0,0-.067-.107h0a.457.457,0,0,0-.065-.066l-.1-.1-.025.019a3.183,3.183,0,0,0-2.591.7c-1.268.828-2.083,1.969-1.848,2.576l-.035.026.141.141.021.021h0a.6.6,0,0,0,.122.085h0a3.136,3.136,0,0,0,2.606-.691C1898.185,712.745,1899.005,711.577,1898.726,710.98Z",
    transform: "translate(-1765.102 -655.672)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M1893.923,709.475c1.293-.844,2.568-1.044,2.847-.447s-.542,1.765-1.835,2.609-2.567,1.044-2.846.447S1892.631,710.319,1893.923,709.475Z",
    transform: "translate(-1763.297 -653.87)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M1896.55,714.767a1.048,1.048,0,0,1-.285-.036.492.492,0,0,1-.332-.265c-.117-.255-.008-.631.3-1.063a5.109,5.109,0,0,1,1.315-1.2h0a3.126,3.126,0,0,1,2.153-.669.493.493,0,0,1,.333.265c.116.254.008.631-.3,1.062a5.084,5.084,0,0,1-1.315,1.2A3.8,3.8,0,0,1,1896.55,714.767Zm2.872-3.177a3.739,3.739,0,0,0-1.82.69,4.99,4.99,0,0,0-1.288,1.179c-.288.4-.395.749-.295.968a.4.4,0,0,0,.272.214.929.929,0,0,0,.255.032,3.739,3.739,0,0,0,1.82-.689,4.993,4.993,0,0,0,1.288-1.18c.288-.4.4-.749.295-.967a.4.4,0,0,0-.272-.214A.951.951,0,0,0,1899.422,711.59Z",
    transform: "translate(-1766.851 -656.464)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M1765.473,412.942a.311.311,0,0,1,.04-.065h0a.278.278,0,0,1,.039-.04l.06-.06.016.012a1.934,1.934,0,0,1,1.576.425c.773.5,1.267,1.2,1.125,1.567l.022.016-.086.085-.013.013h0a.34.34,0,0,1-.077.052h0a1.922,1.922,0,0,1-1.586-.421C1765.8,414.016,1765.3,413.305,1765.473,412.942Z",
    transform: "translate(-1646.493 -380.81)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M1768.385,412.026c-.786-.514-1.562-.636-1.732-.272s.33,1.074,1.116,1.587,1.562.635,1.732.272S1769.172,412.539,1768.385,412.026Z",
    transform: "translate(-1647.582 -379.713)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M1769.98,414.819a3.1,3.1,0,0,1-.8-.732c-.19-.262-.256-.492-.185-.647a.3.3,0,0,1,.2-.161,1.9,1.9,0,0,1,1.31.407h0a3.1,3.1,0,0,1,.8.732c.19.262.256.492.186.647a.3.3,0,0,1-.2.162.626.626,0,0,1-.173.022A2.275,2.275,0,0,1,1769.98,414.819Zm-.766-1.484a.247.247,0,0,0-.166.13c-.061.133,0,.348.179.589a3.042,3.042,0,0,0,.783.718,2.284,2.284,0,0,0,1.108.419.554.554,0,0,0,.155-.019.247.247,0,0,0,.167-.13c.061-.133,0-.347-.18-.589a3.044,3.044,0,0,0-.784-.717,2.284,2.284,0,0,0-1.107-.42A.591.591,0,0,0,1769.215,413.335Z",
    transform: "translate(-1649.749 -381.294)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M940.715,731.206a.6.6,0,0,0-.077-.122h0a.621.621,0,0,0-.077-.077l-.113-.114-.03.022c-.578-.283-1.771.017-2.979.805-1.459.953-2.4,2.265-2.126,2.962l-.041.03.162.162.024.024,0,0h0a.661.661,0,0,0,.141.1h0c.571.3,1.779,0,3-.795C940.092,733.237,941.036,731.893,940.715,731.206Z",
    transform: "translate(-880.529 -674.285)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M935.237,729.5c1.487-.971,2.952-1.2,3.274-.514s-.623,2.03-2.11,3-2.954,1.2-3.273.514S933.751,730.467,935.237,729.5Z",
    transform: "translate(-878.5 -672.233)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M938.249,735.538a1.187,1.187,0,0,1-.327-.041.566.566,0,0,1-.382-.309c-.135-.292-.01-.726.35-1.222a5.793,5.793,0,0,1,1.51-1.383h0a3.577,3.577,0,0,1,2.475-.77.565.565,0,0,1,.383.3c.134.292.01.726-.35,1.222a5.838,5.838,0,0,1-1.509,1.388A4.371,4.371,0,0,1,938.249,735.538Zm3.3-3.654a4.3,4.3,0,0,0-2.093.794,5.733,5.733,0,0,0-1.481,1.356c-.33.456-.454.862-.339,1.112a.464.464,0,0,0,.309.246,1.072,1.072,0,0,0,.294.037,4.308,4.308,0,0,0,2.093-.794,5.764,5.764,0,0,0,1.481-1.356c.33-.456.454-.862.339-1.112a.464.464,0,0,0-.314-.246A1.062,1.062,0,0,0,941.548,731.884Z",
    transform: "translate(-882.579 -675.172)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M764.18,492.254a.338.338,0,0,0-.045-.071h0a.348.348,0,0,0-.044-.045l-.066-.067-.017.013a2.132,2.132,0,0,0-1.735.469c-.851.555-1.392,1.319-1.237,1.725l-.024.018.1.094.014.014h0a.367.367,0,0,0,.082.056h0a2.1,2.1,0,0,0,1.746-.464C763.817,493.438,764.367,492.656,764.18,492.254Z",
    transform: "translate(-719.751 -453.968)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M760.949,491.28c.865-.565,1.719-.7,1.907-.3s-.36,1.183-1.225,1.747-1.719.7-1.906.3S760.086,491.845,760.949,491.28Z",
    transform: "translate(-718.531 -452.794)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M762.7,494.856a.7.7,0,0,1-.191-.025.331.331,0,0,1-.223-.177c-.077-.17-.005-.423.2-.712a3.392,3.392,0,0,1,.879-.805h0a2.08,2.08,0,0,1,1.443-.449.328.328,0,0,1,.222.177c.077.17.006.423-.2.712a3.408,3.408,0,0,1-.879.806A2.58,2.58,0,0,1,762.7,494.856Zm1.923-2.128a2.506,2.506,0,0,0-1.219.464,3.356,3.356,0,0,0-.859.784c-.193.265-.265.5-.2.648a.271.271,0,0,0,.183.143.64.64,0,0,0,.171.021,2.5,2.5,0,0,0,1.219-.464,3.346,3.346,0,0,0,.862-.79c.193-.265.265-.5.2-.647a.268.268,0,0,0-.182-.143.611.611,0,0,0-.174-.019Z",
    transform: "translate(-720.904 -454.559)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M985.323,561.4a.442.442,0,0,1,.057-.09h0a.428.428,0,0,1,.056-.056l.084-.085.021.016a2.723,2.723,0,0,1,2.216.6c1.083.708,1.783,1.685,1.582,2.2l.03.023-.121.12-.018.018h0a.441.441,0,0,1-.1.073h0a2.685,2.685,0,0,1-2.23-.592C985.787,562.909,985.084,561.911,985.323,561.4Z",
    transform: "translate(-926.672 -517.707)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M989.4,560.11c-1.105-.722-2.2-.893-2.435-.382s.464,1.509,1.569,2.231,2.2.893,2.435.382S990.507,560.831,989.4,560.11Z",
    transform: "translate(-928.186 -516.164)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M991.666,564.036a4.363,4.363,0,0,1-1.123-1.029c-.267-.369-.36-.691-.26-.909a.421.421,0,0,1,.285-.227,2.663,2.663,0,0,1,1.842.572h0a4.364,4.364,0,0,1,1.123,1.029c.268.369.36.691.26.909a.421.421,0,0,1-.285.227.871.871,0,0,1-.243.031A3.263,3.263,0,0,1,991.666,564.036Zm-1.076-2.088a.345.345,0,0,0-.232.183c-.085.186.006.488.252.827a4.277,4.277,0,0,0,1.1,1.005,3.221,3.221,0,0,0,1.557.59.817.817,0,0,0,.218-.027.345.345,0,0,0,.232-.183c.085-.186-.006-.488-.252-.827a4.272,4.272,0,0,0-1.1-1.005,3.207,3.207,0,0,0-1.557-.59.81.81,0,0,0-.218.029Z",
    transform: "translate(-931.256 -518.385)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M1216.92,1625.809v1.338a.454.454,0,0,1-.1.286.621.621,0,0,1-.288.193.687.687,0,0,1-.112.026.733.733,0,0,1-.108.009h-25.383a.58.58,0,0,1-.613-.49v-1.392a.58.58,0,0,1,.613-.49h25.383a.7.7,0,0,1,.108.009.676.676,0,0,1,.112.026.62.62,0,0,1,.288.193A.453.453,0,0,1,1216.92,1625.809Z",
    transform: "translate(-1115.847 -1499.581)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M1204.456,1627.711h-13.6a.541.541,0,0,1-.547-.49v-1.392a.541.541,0,0,1,.547-.49h11.928A4.159,4.159,0,0,0,1204.456,1627.711Z",
    transform: "translate(-1115.847 -1499.626)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.696 125.711)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.719 125.711)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.548 125.711)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 0.288,
    height: 2.37,
    transform: "translate(93.754 125.711)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.856 125.711)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 0.288,
    height: 2.37,
    transform: "translate(88.946 125.711)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 0.288,
    height: 2.37,
    transform: "translate(86.221 125.711)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 0.288,
    height: 2.37,
    transform: "translate(83.789 125.711)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 0.288,
    height: 2.37,
    transform: "translate(98.625 125.711)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 0.288,
    height: 2.37,
    transform: "translate(99.239 125.711)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 0.288,
    height: 2.37,
    transform: "translate(99.832 125.711)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M1524.369,1625.328v2.353a.7.7,0,0,1-.108.009h-.18v-2.37h.18A.7.7,0,0,1,1524.369,1625.328Z",
    transform: "translate(-1423.801 -1499.609)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M1529.558,1625.954v1.913a.616.616,0,0,1-.288.193v-2.3A.617.617,0,0,1,1529.558,1625.954Z",
    transform: "translate(-1428.59 -1500.015)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M1181.839,1595.205v1.339a.458.458,0,0,1-.105.288.608.608,0,0,1-.288.193.666.666,0,0,1-.113.027.7.7,0,0,1-.108.008h-25.382a.579.579,0,0,1-.613-.489v-1.392a.579.579,0,0,1,.613-.489h25.49a.691.691,0,0,1,.113.027l.016.005.015.006.031.012.018.009.015.008.029.015.031.019.024.016h0l.015.011a.426.426,0,0,1,.045.039l.012.012.012.012.022.026A.458.458,0,0,1,1181.839,1595.205Z",
    transform: "translate(-1083.48 -1471.348)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M1169.376,1597.057h-13.6a.536.536,0,0,1-.548-.489v-1.391a.536.536,0,0,1,.548-.489h11.928c.005.019.011.039.017.058A4.141,4.141,0,0,0,1169.376,1597.057Z",
    transform: "translate(-1083.48 -1471.346)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.982 123.342)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.006 123.342)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.835 123.342)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.04 123.342)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 0.288,
    height: 2.37,
    transform: "translate(89.142 123.342)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 0.288,
    height: 2.37,
    transform: "translate(86.232 123.342)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 0.288,
    height: 2.37,
    transform: "translate(83.507 123.342)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 0.288,
    height: 2.37,
    transform: "translate(81.074 123.342)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.912 123.342)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.526 123.342)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.118 123.342)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M1489.288,1594.7v2.354a.7.7,0,0,1-.108.008H1489v-2.369h.18A.722.722,0,0,1,1489.288,1594.7Z",
    transform: "translate(-1391.435 -1471.348)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M1494.458,1595.333v1.914a.607.607,0,0,1-.288.193v-2.3A.607.607,0,0,1,1494.458,1595.333Z",
    transform: "translate(-1396.205 -1471.763)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M1198.818,1565.325v1.339a.458.458,0,0,1-.105.288.613.613,0,0,1-.288.193.662.662,0,0,1-.112.027.732.732,0,0,1-.108.008h-25.383a.711.711,0,0,1-.283-.058.527.527,0,0,1-.328-.408V1565.3a.58.58,0,0,1,.613-.489h25.382a.7.7,0,0,1,.108.008.674.674,0,0,1,.112.027.614.614,0,0,1,.289.193.459.459,0,0,1,.1.288Z",
    transform: "translate(-1099.147 -1443.779)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M1186.354,1567.177h-13.6a.571.571,0,0,1-.252-.058.517.517,0,0,1-.293-.407V1565.3a.537.537,0,0,1,.547-.489h11.928a4.161,4.161,0,0,0,1.586,2.311Z",
    transform: "translate(-1099.147 -1443.777)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.294 121.031)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.317 121.031)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.146 121.031)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.351 121.031)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 0.288,
    height: 2.37,
    transform: "translate(90.453 121.031)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 0.288,
    height: 2.37,
    transform: "translate(87.543 121.031)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 0.288,
    height: 2.37,
    transform: "translate(84.819 121.031)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 0.288,
    height: 2.37,
    transform: "translate(82.386 121.031)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.223 121.031)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.837 121.031)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 0.288,
    height: 2.37,
    transform: "translate(98.43 121.031)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M1506.285,1564.818v2.353a.631.631,0,0,1-.108.009H1506v-2.369h.18A.711.711,0,0,1,1506.285,1564.818Z",
    transform: "translate(-1407.12 -1443.779)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M1511.418,1565.453v1.914a.613.613,0,0,1-.288.193v-2.3A.613.613,0,0,1,1511.418,1565.453Z",
    transform: "translate(-1411.853 -1444.194)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M1206.677,1534.732v1.338a.453.453,0,0,1-.105.288.619.619,0,0,1-.289.194.662.662,0,0,1-.112.026.7.7,0,0,1-.108.009h-25.38a.581.581,0,0,1-.614-.49V1534.7a.567.567,0,0,1,.542-.485h25.454a.731.731,0,0,1,.108.008.691.691,0,0,1,.112.026.611.611,0,0,1,.289.193A.455.455,0,0,1,1206.677,1534.732Z",
    transform: "translate(-1106.399 -1415.555)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M1194.186,1536.576h-13.6a.542.542,0,0,1-.548-.49v-1.391a.533.533,0,0,1,.483-.485.64.64,0,0,1,.065,0h11.928A4.155,4.155,0,0,0,1194.186,1536.576Z",
    transform: "translate(-1106.371 -1415.545)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.902 118.661)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.925 118.661)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.754 118.661)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.959 118.661)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.061 118.661)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 0.288,
    height: 2.37,
    transform: "translate(88.151 118.661)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 0.288,
    height: 2.37,
    transform: "translate(85.427 118.661)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 0.288,
    height: 2.37,
    transform: "translate(82.994 118.661)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.831 118.661)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 0.288,
    height: 2.37,
    transform: "translate(98.445 118.661)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 0.288,
    height: 2.37,
    transform: "translate(99.038 118.661)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M1514.1,1534.179v2.353a.715.715,0,0,1-.108.008h-.18v-2.37h.18A.7.7,0,0,1,1514.1,1534.179Z",
    transform: "translate(-1414.326 -1415.509)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M1519.279,1534.813v1.914a.618.618,0,0,1-.289.193v-2.3A.615.615,0,0,1,1519.279,1534.813Z",
    transform: "translate(-1419.105 -1415.924)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M1182.529,1504.1v1.338a.454.454,0,0,1-.105.288.609.609,0,0,1-.288.193.682.682,0,0,1-.112.026l-.036,0H1156.53a.58.58,0,0,1-.613-.49v-1.391a.16.16,0,0,1,0-.022.554.554,0,0,1,.464-.452h.019a.737.737,0,0,1,.133-.012h25.487a.643.643,0,0,1,.112.026.611.611,0,0,1,.288.193A.455.455,0,0,1,1182.529,1504.1Z",
    transform: "translate(-1084.113 -1387.285)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M1170.062,1505.95h-13.6a.537.537,0,0,1-.548-.49v-1.391a.161.161,0,0,1,0-.022.528.528,0,0,1,.425-.455l.023,0a.606.606,0,0,1,.1-.009h11.928a.119.119,0,0,0,0,.017,4.155,4.155,0,0,0,1.659,2.349Z",
    transform: "translate(-1084.113 -1387.284)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.035 116.295)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.059 116.295)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.887 116.295)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.093 116.295)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 0.288,
    height: 2.37,
    transform: "translate(89.195 116.295)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 0.288,
    height: 2.37,
    transform: "translate(86.285 116.295)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 0.288,
    height: 2.37,
    transform: "translate(83.56 116.295)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 0.288,
    height: 2.37,
    transform: "translate(81.128 116.295)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.965 116.295)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.579 116.295)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.172 116.295)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M1489.969,1503.588v2.353a.7.7,0,0,1-.108.009h-.18v-2.37h.179A.727.727,0,0,1,1489.969,1503.588Z",
    transform: "translate(-1392.062 -1387.284)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M1495.148,1504.2v1.914a.612.612,0,0,1-.288.193V1504A.609.609,0,0,1,1495.148,1504.2Z",
    transform: "translate(-1396.841 -1387.672)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M1181.867,1473.676v1.338a.454.454,0,0,1-.105.288.6.6,0,0,1-.288.193.666.666,0,0,1-.088.022h-.024a.685.685,0,0,1-.108.008h-25.382a.628.628,0,0,1-.077,0h-.03a.558.558,0,0,1-.5-.48v-1.391a.58.58,0,0,1,.613-.49h25.49a.7.7,0,0,1,.113.026l.016.005.015.006.031.012c.012.005.022.01.033.016l.029.015.031.019.024.016h0l.016.011c.016.012.031.026.045.039l.012.012.012.012a.305.305,0,0,1,.022.026A.454.454,0,0,1,1181.867,1473.676Z",
    transform: "translate(-1083.508 -1359.218)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M1169.376,1475.574H1155.71a.532.532,0,0,1-.48-.485V1473.7a.537.537,0,0,1,.548-.49h11.928c.005.019.011.039.017.059a4.145,4.145,0,0,0,1.629,2.294Z",
    transform: "translate(-1083.48 -1359.262)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.982 113.942)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.006 113.942)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.835 113.942)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.04 113.942)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 0.288,
    height: 2.37,
    transform: "translate(89.142 113.942)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 0.288,
    height: 2.37,
    transform: "translate(86.232 113.942)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 0.288,
    height: 2.37,
    transform: "translate(83.507 113.942)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 0.288,
    height: 2.37,
    transform: "translate(81.074 113.942)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.912 113.942)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.526 113.942)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.118 113.942)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M1489.288,1473.168v2.353a.713.713,0,0,1-.108.009H1489v-2.37h.18A.706.706,0,0,1,1489.288,1473.168Z",
    transform: "translate(-1391.435 -1359.218)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M1494.458,1473.8v1.914a.606.606,0,0,1-.288.193v-2.3A.61.61,0,0,1,1494.458,1473.8Z",
    transform: "translate(-1396.205 -1359.633)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M1198.818,1443.846v1.338a.454.454,0,0,1-.105.287.619.619,0,0,1-.289.193.675.675,0,0,1-.112.026.729.729,0,0,1-.108.009h-25.383a.7.7,0,0,1-.283-.059.526.526,0,0,1-.328-.408v-1.414a.58.58,0,0,1,.613-.49h25.382a.714.714,0,0,1,.108.009.687.687,0,0,1,.112.026.62.62,0,0,1,.289.193A.454.454,0,0,1,1198.818,1443.846Z",
    transform: "translate(-1099.147 -1331.695)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M1186.354,1445.7h-13.6a.561.561,0,0,1-.252-.059.516.516,0,0,1-.293-.408v-1.41a.541.541,0,0,1,.547-.49h11.928a4.156,4.156,0,0,0,1.586,2.311Z",
    transform: "translate(-1099.147 -1331.694)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.294 111.632)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.317 111.632)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.146 111.632)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.351 111.632)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 0.288,
    height: 2.37,
    transform: "translate(90.453 111.632)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 0.288,
    height: 2.37,
    transform: "translate(87.543 111.632)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 0.288,
    height: 2.37,
    transform: "translate(84.819 111.632)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 0.288,
    height: 2.37,
    transform: "translate(82.386 111.632)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.223 111.632)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.837 111.632)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 0.288,
    height: 2.37,
    transform: "translate(98.43 111.632)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M1506.285,1443.288v2.353a.7.7,0,0,1-.108.009H1506v-2.37h.18A.7.7,0,0,1,1506.285,1443.288Z",
    transform: "translate(-1407.12 -1331.649)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M1511.418,1443.951v1.916a.606.606,0,0,1-.288.193v-2.3A.62.62,0,0,1,1511.418,1443.951Z",
    transform: "translate(-1411.853 -1332.091)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M1225.607,1413.2v1.339a.457.457,0,0,1-.105.288.605.605,0,0,1-.288.193.681.681,0,0,1-.113.027.689.689,0,0,1-.108.008h-25.38a.579.579,0,0,1-.613-.489v-1.391a.566.566,0,0,1,.542-.485.6.6,0,0,1,.073,0H1225a.688.688,0,0,1,.108.008.661.661,0,0,1,.113.027.606.606,0,0,1,.288.193A.456.456,0,0,1,1225.607,1413.2Z",
    transform: "translate(-1123.865 -1303.42)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M1213.146,1415.088h-13.6a.536.536,0,0,1-.548-.486v-1.391a.532.532,0,0,1,.483-.485.444.444,0,0,1,.065,0h11.928A4.152,4.152,0,0,0,1213.146,1415.088Z",
    transform: "translate(-1123.865 -1303.457)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 0.288,
    height: 2.37,
    transform: "translate(98.368 109.262)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.391 109.262)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.22 109.262)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.425 109.262)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.527 109.262)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 0.288,
    height: 2.37,
    transform: "translate(89.617 109.262)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 0.288,
    height: 2.37,
    transform: "translate(86.893 109.262)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 0.288,
    height: 2.37,
    transform: "translate(84.461 109.262)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 0.288,
    height: 2.37,
    transform: "translate(99.297 109.262)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 0.288,
    height: 2.37,
    transform: "translate(99.911 109.262)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 0.288,
    height: 2.37,
    transform: "translate(100.504 109.262)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M1533.058,1412.658v2.354a.731.731,0,0,1-.108.008h-.18v-2.369h.18A.748.748,0,0,1,1533.058,1412.658Z",
    transform: "translate(-1431.819 -1303.388)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M1538.239,1413.292v1.915a.614.614,0,0,1-.289.193v-2.3A.613.613,0,0,1,1538.239,1413.292Z",
    transform: "translate(-1436.598 -1303.803)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M1182.533,1382.5v1.336a.455.455,0,0,1-.105.288.6.6,0,0,1-.288.193.643.643,0,0,1-.112.027l-.036,0h-25.458a.58.58,0,0,1-.613-.49v-1.392a.579.579,0,0,1,.613-.489h25.414a.571.571,0,0,1,.078.008.606.606,0,0,1,.112.026c.018.006.036.013.053.02s.022.008.032.014h0l.03.016h.005l.028.017a.477.477,0,0,1,.061.045l.017.015h0l.011.009h0l.018.018.025.028A.458.458,0,0,1,1182.533,1382.5Z",
    transform: "translate(-1084.117 -1275.09)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1170.066,1384.428h-13.6a.537.537,0,0,1-.548-.49v-1.391a.536.536,0,0,1,.548-.489H1168.4c0,.018.009.036.016.055a4.149,4.149,0,0,0,1.648,2.311Z",
    transform: "translate(-1084.117 -1275.162)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.035 106.896)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.059 106.896)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.887 106.896)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.093 106.896)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 0.288,
    height: 2.37,
    transform: "translate(89.195 106.896)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 0.288,
    height: 2.37,
    transform: "translate(86.285 106.896)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 0.288,
    height: 2.37,
    transform: "translate(83.56 106.896)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 0.288,
    height: 2.37,
    transform: "translate(81.128 106.896)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.965 106.896)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.579 106.896)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.172 106.896)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M1489.969,1382.068v2.353a.716.716,0,0,1-.108.009h-.18v-2.37h.179A.711.711,0,0,1,1489.969,1382.068Z",
    transform: "translate(-1392.062 -1275.164)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M1495.148,1382.7v1.914a.606.606,0,0,1-.288.193v-2.3A.6.6,0,0,1,1495.148,1382.7Z",
    transform: "translate(-1396.841 -1275.579)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M1206.7,1352.692v1.338a.455.455,0,0,1-.105.288.618.618,0,0,1-.289.193.652.652,0,0,1-.112.026.685.685,0,0,1-.108.009H1180.7a.7.7,0,0,1-.274-.055.529.529,0,0,1-.338-.414.147.147,0,0,0,0-.021v-1.392a.567.567,0,0,1,.541-.485h25.454a.715.715,0,0,1,.108.009.671.671,0,0,1,.112.026.607.607,0,0,1,.288.193A.455.455,0,0,1,1206.7,1352.692Z",
    transform: "translate(-1106.417 -1247.595)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M1194.2,1354.536h-13.6a.572.572,0,0,1-.244-.055.521.521,0,0,1-.3-.414.2.2,0,0,0,0-.021v-1.391a.533.533,0,0,1,.483-.485.64.64,0,0,1,.065,0h11.928a4.157,4.157,0,0,0,1.59,2.311Z",
    transform: "translate(-1106.39 -1247.585)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.902 104.581)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.925 104.581)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.754 104.581)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.959 104.581)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.061 104.581)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 0.288,
    height: 2.37,
    transform: "translate(88.151 104.581)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 0.288,
    height: 2.37,
    transform: "translate(85.427 104.581)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 0.288,
    height: 2.37,
    transform: "translate(82.994 104.581)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.831 104.581)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 0.288,
    height: 2.37,
    transform: "translate(98.445 104.581)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 0.288,
    height: 2.37,
    transform: "translate(99.038 104.581)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M1514.1,1352.138v2.353a.685.685,0,0,1-.108.008h-.18v-2.37h.18A.7.7,0,0,1,1514.1,1352.138Z",
    transform: "translate(-1414.326 -1247.549)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M1519.279,1352.773v1.913a.622.622,0,0,1-.289.193v-2.3A.612.612,0,0,1,1519.279,1352.773Z",
    transform: "translate(-1419.105 -1247.964)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M1216.92,1321.991v1.338a.453.453,0,0,1-.105.288.62.62,0,0,1-.288.193.641.641,0,0,1-.112.026l-.035,0h-25.455a.58.58,0,0,1-.613-.49v-1.392a.58.58,0,0,1,.613-.49h25.383a.763.763,0,0,1,.108.009.664.664,0,0,1,.112.026.618.618,0,0,1,.288.193A.452.452,0,0,1,1216.92,1321.991Z",
    transform: "translate(-1115.847 -1219.26)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M1204.456,1323.891h-13.6a.541.541,0,0,1-.547-.49v-1.392a.541.541,0,0,1,.547-.49h11.928a4.151,4.151,0,0,0,1.664,2.366Z",
    transform: "translate(-1115.847 -1219.306)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.696 102.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.719 102.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.548 102.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 0.288,
    height: 2.37,
    transform: "translate(93.754 102.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.856 102.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 0.288,
    height: 2.37,
    transform: "translate(88.946 102.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 0.288,
    height: 2.37,
    transform: "translate(86.221 102.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 0.288,
    height: 2.37,
    transform: "translate(83.789 102.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 0.288,
    height: 2.37,
    transform: "translate(98.626 102.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 0.288,
    height: 2.37,
    transform: "translate(99.24 102.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 0.288,
    height: 2.37,
    transform: "translate(99.832 102.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M1524.369,1321.549v2.353a.747.747,0,0,1-.108.009h-.18v-2.37h.18A.684.684,0,0,1,1524.369,1321.549Z",
    transform: "translate(-1423.801 -1219.325)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M1529.558,1322.193v1.913a.618.618,0,0,1-.288.193V1322A.617.617,0,0,1,1529.558,1322.193Z",
    transform: "translate(-1428.59 -1219.749)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M1199.859,1290.9v1.338a.456.456,0,0,1-.105.288.616.616,0,0,1-.288.193.69.69,0,0,1-.113.026.7.7,0,0,1-.108.009h-25.382a.58.58,0,0,1-.613-.49v-1.391a.58.58,0,0,1,.613-.49h25.382a.753.753,0,0,1,.221.035.615.615,0,0,1,.288.193A.456.456,0,0,1,1199.859,1290.9Z",
    transform: "translate(-1100.106 -1190.575)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M1187.4,1292.728h-13.6a.537.537,0,0,1-.548-.49v-1.391a.537.537,0,0,1,.548-.49h11.928A4.154,4.154,0,0,0,1187.4,1292.728Z",
    transform: "translate(-1100.106 -1190.555)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.376 99.805)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.4 99.805)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.229 99.805)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.433 99.805)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 0.288,
    height: 2.37,
    transform: "translate(90.535 99.805)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 0.288,
    height: 2.37,
    transform: "translate(87.626 99.805)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 0.288,
    height: 2.37,
    transform: "translate(84.902 99.805)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 0.288,
    height: 2.37,
    transform: "translate(82.468 99.805)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.305 99.805)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.92 99.805)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 0.288,
    height: 2.37,
    transform: "translate(98.512 99.805)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M1507.289,1290.389v2.353a.7.7,0,0,1-.108.009H1507v-2.37h.18A.692.692,0,0,1,1507.289,1290.389Z",
    transform: "translate(-1408.042 -1190.575)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M1512.488,1291.023v1.913a.615.615,0,0,1-.288.193v-2.3A.615.615,0,0,1,1512.488,1291.023Z",
    transform: "translate(-1412.84 -1190.99)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M1164.77,1260.256v1.338a.458.458,0,0,1-.105.288.614.614,0,0,1-.289.193.608.608,0,0,1-.112.026.715.715,0,0,1-.108.008h-25.383a.58.58,0,0,1-.613-.489v-1.391a.58.58,0,0,1,.613-.49h25.491a.778.778,0,0,1,.112.026l.016.005.015.006.031.012.018.009.015.008.029.015.032.019.024.016h0l.015.012a.444.444,0,0,1,.045.038l.012.012.011.012.023.026A.454.454,0,0,1,1164.77,1260.256Z",
    transform: "translate(-1067.73 -1162.305)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M1152.306,1262.108h-13.6a.536.536,0,0,1-.548-.489v-1.391a.536.536,0,0,1,.548-.489h11.928l.016.059A4.149,4.149,0,0,0,1152.306,1262.108Z",
    transform: "translate(-1067.73 -1162.303)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 0.288,
    height: 2.37,
    transform: "translate(93.662 97.435)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.686 97.435)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.515 97.435)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 0.288,
    height: 2.37,
    transform: "translate(89.719 97.435)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 0.288,
    height: 2.37,
    transform: "translate(87.821 97.435)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 0.288,
    height: 2.37,
    transform: "translate(84.912 97.435)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 0.288,
    height: 2.37,
    transform: "translate(82.188 97.435)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 0.288,
    height: 2.37,
    transform: "translate(79.755 97.435)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.591 97.435)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.206 97.435)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.799 97.435)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M1472.219,1259.748v2.353a.7.7,0,0,1-.108.008h-.18v-2.37h.18A.716.716,0,0,1,1472.219,1259.748Z",
    transform: "translate(-1375.685 -1162.304)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M1477.4,1260.383v1.915a.613.613,0,0,1-.288.193v-2.3A.62.62,0,0,1,1477.4,1260.383Z",
    transform: "translate(-1380.464 -1162.72)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M1181.744,1230.376v1.338a.459.459,0,0,1-.105.288.652.652,0,0,1-.4.219.718.718,0,0,1-.108.008h-25.382a.693.693,0,0,1-.283-.059.526.526,0,0,1-.329-.408.172.172,0,0,1,0-.022v-1.391a.58.58,0,0,1,.613-.49h25.382a.7.7,0,0,1,.108.009.653.653,0,0,1,.112.026.612.612,0,0,1,.289.193A.454.454,0,0,1,1181.744,1230.376Z",
    transform: "translate(-1083.394 -1134.736)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M1169.28,1232.228h-13.6a.567.567,0,0,1-.253-.059.518.518,0,0,1-.293-.408.171.171,0,0,1,0-.022v-1.392a.536.536,0,0,1,.547-.489h11.928a4.152,4.152,0,0,0,1.586,2.311C1169.224,1232.189,1169.252,1232.209,1169.28,1232.228Z",
    transform: "translate(-1083.394 -1134.734)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.974 95.125)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 0.288,
    height: 2.37,
    transform: "translate(93.997 95.125)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.826 95.125)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.031 95.125)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 0.288,
    height: 2.37,
    transform: "translate(89.133 95.125)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 0.288,
    height: 2.37,
    transform: "translate(86.223 95.125)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 0.288,
    height: 2.37,
    transform: "translate(83.498 95.125)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 0.288,
    height: 2.37,
    transform: "translate(81.066 95.125)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.903 95.125)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.517 95.125)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.11 95.125)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M1489.168,1229.9v2.353a.7.7,0,0,1-.108.009h-.18v-2.37h.18A.714.714,0,0,1,1489.168,1229.9Z",
    transform: "translate(-1391.324 -1134.764)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M1494.349,1230.5v1.914a.6.6,0,0,1-.288.193v-2.3A.613.613,0,0,1,1494.349,1230.5Z",
    transform: "translate(-1396.103 -1135.151)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M1189.589,1199.778v1.338a.455.455,0,0,1-.105.288.608.608,0,0,1-.288.193.68.68,0,0,1-.113.027.666.666,0,0,1-.108.008h-25.381a.579.579,0,0,1-.613-.489v-1.391a.565.565,0,0,1,.542-.485.6.6,0,0,1,.073,0h25.382a.852.852,0,0,1,.108.008.681.681,0,0,1,.113.027.606.606,0,0,1,.288.193A.458.458,0,0,1,1189.589,1199.778Z",
    transform: "translate(-1090.631 -1106.507)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M1177.126,1201.631h-13.6a.536.536,0,0,1-.548-.489v-1.392a.532.532,0,0,1,.483-.485.48.48,0,0,1,.065,0h11.928A4.15,4.15,0,0,0,1177.126,1201.631Z",
    transform: "translate(-1090.631 -1106.507)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.581 92.755)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.605 92.755)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 0.288,
    height: 2.37,
    transform: "translate(93.434 92.755)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.639 92.755)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 0.288,
    height: 2.37,
    transform: "translate(89.741 92.755)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 0.288,
    height: 2.37,
    transform: "translate(86.831 92.755)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 0.288,
    height: 2.37,
    transform: "translate(84.106 92.755)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 0.288,
    height: 2.37,
    transform: "translate(81.674 92.755)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.511 92.755)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.125 92.755)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.718 92.755)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M1497.029,1199.238v2.354a.7.7,0,0,1-.108.008h-.18v-2.369h.18A.7.7,0,0,1,1497.029,1199.238Z",
    transform: "translate(-1398.576 -1106.475)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M1502.218,1199.873v1.914a.606.606,0,0,1-.288.193v-2.3A.606.606,0,0,1,1502.218,1199.873Z",
    transform: "translate(-1403.365 -1106.89)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M1165.46,1169.156v1.338a.451.451,0,0,1-.106.288.615.615,0,0,1-.288.193.677.677,0,0,1-.112.026l-.036,0h-25.454a.58.58,0,0,1-.613-.49V1169.1a.556.556,0,0,1,.464-.451h.019a.747.747,0,0,1,.132-.012h25.492a.649.649,0,0,1,.4.219A.454.454,0,0,1,1165.46,1169.156Z",
    transform: "translate(-1068.367 -1078.251)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M1153,1171.01h-13.6a.537.537,0,0,1-.547-.49v-1.413a.53.53,0,0,1,.425-.454l.023,0a.589.589,0,0,1,.1-.008h11.928l0,.017a4.155,4.155,0,0,0,1.66,2.349Z",
    transform: "translate(-1068.367 -1078.251)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 0.288,
    height: 2.37,
    transform: "translate(93.715 90.389)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.739 90.389)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.568 90.389)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 0.288,
    height: 2.37,
    transform: "translate(89.773 90.389)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 0.288,
    height: 2.37,
    transform: "translate(87.875 90.389)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 0.288,
    height: 2.37,
    transform: "translate(84.965 90.389)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 0.288,
    height: 2.37,
    transform: "translate(82.241 90.389)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 0.288,
    height: 2.37,
    transform: "translate(79.808 90.389)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.645 90.389)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.259 90.389)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.852 90.389)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M1472.9,1168.648V1171a.715.715,0,0,1-.108.009h-.181v-2.37h.185A.711.711,0,0,1,1472.9,1168.648Z",
    transform: "translate(-1376.312 -1078.251)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M1478.088,1169.282v1.915a.616.616,0,0,1-.288.193v-2.3A.607.607,0,0,1,1478.088,1169.282Z",
    transform: "translate(-1381.101 -1078.666)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M1164.788,1138.736v1.338a.454.454,0,0,1-.105.288.619.619,0,0,1-.289.193.671.671,0,0,1-.087.022h-.024a.7.7,0,0,1-.108.008h-25.383a.655.655,0,0,1-.077,0h-.031a.559.559,0,0,1-.5-.481v-1.391a.58.58,0,0,1,.613-.49h25.491a.7.7,0,0,1,.112.026l.016.005.016.006.031.012.033.015.029.016.032.02.024.016h0l.015.011a.542.542,0,0,1,.045.039l.012.012.012.013.023.026a.455.455,0,0,1,.1.3Z",
    transform: "translate(-1067.749 -1050.184)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M1152.306,1140.634H1138.64a.533.533,0,0,1-.48-.486v-1.391a.537.537,0,0,1,.548-.49h11.928l.016.059a4.153,4.153,0,0,0,1.629,2.294Z",
    transform: "translate(-1067.73 -1050.228)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 0.288,
    height: 2.37,
    transform: "translate(93.662 88.036)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.686 88.036)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.515 88.036)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 0.288,
    height: 2.37,
    transform: "translate(89.719 88.036)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 0.288,
    height: 2.37,
    transform: "translate(87.821 88.036)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 0.288,
    height: 2.37,
    transform: "translate(84.912 88.036)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 0.288,
    height: 2.37,
    transform: "translate(82.188 88.036)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 0.288,
    height: 2.37,
    transform: "translate(79.755 88.036)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.591 88.036)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.206 88.036)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.799 88.036)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M1472.219,1138.229v2.353a.732.732,0,0,1-.108.009h-.18v-2.37h.18A.732.732,0,0,1,1472.219,1138.229Z",
    transform: "translate(-1375.685 -1050.184)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M1477.4,1138.863v1.914a.618.618,0,0,1-.288.193v-2.3A.617.617,0,0,1,1477.4,1138.863Z",
    transform: "translate(-1380.464 -1050.599)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M1181.748,1108.846v1.338a.453.453,0,0,1-.105.288.613.613,0,0,1-.289.193.64.64,0,0,1-.112.026.713.713,0,0,1-.108.008h-25.382a.7.7,0,0,1-.283-.059.527.527,0,0,1-.329-.408v-1.414a.58.58,0,0,1,.614-.49h25.382a.7.7,0,0,1,.108.009.641.641,0,0,1,.112.026.606.606,0,0,1,.288.193A.453.453,0,0,1,1181.748,1108.846Z",
    transform: "translate(-1083.397 -1022.606)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M1169.283,1110.7h-13.6a.574.574,0,0,1-.253-.059.518.518,0,0,1-.293-.408v-1.416a.537.537,0,0,1,.548-.49h11.928a4.156,4.156,0,0,0,1.586,2.311C1169.228,1110.66,1169.255,1110.679,1169.283,1110.7Z",
    transform: "translate(-1083.397 -1022.604)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.974 85.725)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 0.288,
    height: 2.37,
    transform: "translate(93.997 85.725)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 0.288,
    height: 2.37,
    transform: "translate(92.826 85.725)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.031 85.725)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 0.288,
    height: 2.37,
    transform: "translate(89.133 85.725)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 0.288,
    height: 2.37,
    transform: "translate(86.223 85.725)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 0.288,
    height: 2.37,
    transform: "translate(83.498 85.725)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 0.288,
    height: 2.37,
    transform: "translate(81.066 85.725)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 0.288,
    height: 2.37,
    transform: "translate(95.903 85.725)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.517 85.725)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.11 85.725)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M1489.168,1108.349v2.353a.684.684,0,0,1-.108.009h-.18v-2.37h.18A.731.731,0,0,1,1489.168,1108.349Z",
    transform: "translate(-1391.324 -1022.615)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M1494.349,1108.956v1.911a.613.613,0,0,1-.288.193v-2.3A.612.612,0,0,1,1494.349,1108.956Z",
    transform: "translate(-1396.103 -1023.002)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M1208.542,1078.253v1.338a.458.458,0,0,1-.105.289.614.614,0,0,1-.288.193.578.578,0,0,1-.112.026.712.712,0,0,1-.108.009h-25.385a.58.58,0,0,1-.613-.489v-1.392a.567.567,0,0,1,.542-.486h25.452a.715.715,0,0,1,.108.008.738.738,0,0,1,.112.026.618.618,0,0,1,.288.193A.453.453,0,0,1,1208.542,1078.253Z",
    transform: "translate(-1108.115 -994.381)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M1196.067,1080.1h-13.6a.537.537,0,0,1-.548-.489v-1.392a.534.534,0,0,1,.483-.486.626.626,0,0,1,.064,0H1194.4A4.152,4.152,0,0,0,1196.067,1080.1Z",
    transform: "translate(-1108.106 -994.371)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.048 83.356)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 0.288,
    height: 2.37,
    transform: "translate(96.071 83.356)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 0.288,
    height: 2.37,
    transform: "translate(94.9 83.356)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 0.288,
    height: 2.37,
    transform: "translate(93.106 83.356)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 0.288,
    height: 2.37,
    transform: "translate(91.208 83.356)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 0.288,
    height: 2.37,
    transform: "translate(88.298 83.356)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 0.288,
    height: 2.37,
    transform: "translate(85.573 83.356)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 0.288,
    height: 2.37,
    transform: "translate(83.14 83.356)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 0.288,
    height: 2.37,
    transform: "translate(97.978 83.356)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 0.288,
    height: 2.37,
    transform: "translate(98.592 83.356)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 0.288,
    height: 2.37,
    transform: "translate(99.184 83.356)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M1515.989,1077.708v2.353a.748.748,0,0,1-.108.008h-.18v-2.37h.178A.731.731,0,0,1,1515.989,1077.708Z",
    transform: "translate(-1416.069 -994.345)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M1521.168,1078.343v1.914a.605.605,0,0,1-.289.193v-2.3A.613.613,0,0,1,1521.168,1078.343Z",
    transform: "translate(-1420.849 -994.76)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M1773.171,1624.916v1.338a.455.455,0,0,1-.106.288.66.66,0,0,1-.4.219.68.68,0,0,1-.109.009h-25.382a.591.591,0,0,1-.608-.438.4.4,0,0,1-.006-.051v-1.392a.373.373,0,0,1,.006-.049.594.594,0,0,1,.608-.439h25.382a.856.856,0,0,1,.109.007.734.734,0,0,1,.112.027.6.6,0,0,1,.288.193A.456.456,0,0,1,1773.171,1624.916Z",
    transform: "translate(-1629.073 -1498.76)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M1760.706,1626.683h-13.6a.541.541,0,0,1-.527-.387.363.363,0,0,1-.015-.056.4.4,0,0,1-.006-.051V1624.8a.374.374,0,0,1,.006-.05.381.381,0,0,1,.015-.057.541.541,0,0,1,.527-.382h11.928A4.154,4.154,0,0,0,1760.706,1626.683Z",
    transform: "translate(-1629.073 -1498.676)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.72 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 0.288,
    height: 2.37,
    transform: "translate(139.743 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.572 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 0.288,
    height: 2.37,
    transform: "translate(136.777 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 0.288,
    height: 2.37,
    transform: "translate(134.879 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 0.288,
    height: 2.37,
    transform: "translate(131.969 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 0.288,
    height: 2.37,
    transform: "translate(129.245 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 0.288,
    height: 2.37,
    transform: "translate(126.812 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 0.288,
    height: 2.37,
    transform: "translate(141.649 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 0.288,
    height: 2.37,
    transform: "translate(142.263 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 0.288,
    height: 2.37,
    transform: "translate(142.857 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M2080.618,1624.408v2.353a.7.7,0,0,1-.108.009h-.18v-2.37h.18A.7.7,0,0,1,2080.618,1624.408Z",
    transform: "translate(-1937.028 -1498.76)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M2085.808,1625.044v1.913a.61.61,0,0,1-.288.193v-2.3A.612.612,0,0,1,2085.808,1625.044Z",
    transform: "translate(-1941.816 -1499.175)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M1738.089,1594.258v1.338a.453.453,0,0,1-.1.287.612.612,0,0,1-.289.194.656.656,0,0,1-.113.026l-.053.006h-25.436a.593.593,0,0,1-.609-.439.408.408,0,0,1-.005-.05v-1.391a.335.335,0,0,1,.005-.049.594.594,0,0,1,.609-.439h25.487a.609.609,0,0,1,.113.026l.016,0,.016.006.012,0,.019.008.017.008h.005l.011,0,.029.016a.63.63,0,0,1,.073.049l.029.025a.611.611,0,0,1,.062.064A.453.453,0,0,1,1738.089,1594.258Z",
    transform: "translate(-1596.707 -1470.471)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M1725.626,1596.056h-13.6a.541.541,0,0,1-.528-.387c-.005-.019-.011-.037-.015-.056a.408.408,0,0,1-.005-.05v-1.391a.338.338,0,0,1,.005-.05.21.21,0,0,1,.015-.056.541.541,0,0,1,.528-.387h11.927c.006.019.011.039.017.058a4.315,4.315,0,0,0,.552,1.2A4.056,4.056,0,0,0,1725.626,1596.056Z",
    transform: "translate(-1596.707 -1470.415)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.006 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 0.288,
    height: 2.37,
    transform: "translate(137.029 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 0.288,
    height: 2.37,
    transform: "translate(135.858 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 0.288,
    height: 2.37,
    transform: "translate(134.063 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 0.288,
    height: 2.37,
    transform: "translate(132.165 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 0.288,
    height: 2.37,
    transform: "translate(129.255 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 0.288,
    height: 2.37,
    transform: "translate(126.531 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 0.288,
    height: 2.37,
    transform: "translate(124.099 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.935 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 0.288,
    height: 2.37,
    transform: "translate(139.549 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    "data-name": "Rectangle 314",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.143 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M2045.559,1593.778v2.353a.632.632,0,0,1-.108.009h-.18v-2.369h.18A.731.731,0,0,1,2045.559,1593.778Z",
    transform: "translate(-1904.68 -1470.499)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M2050.719,1594.412v1.914a.613.613,0,0,1-.289.193v-2.3A.613.613,0,0,1,2050.719,1594.412Z",
    transform: "translate(-1909.441 -1470.914)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M1755.07,1564.4v1.338a.456.456,0,0,1-.1.288.627.627,0,0,1-.289.193.746.746,0,0,1-.221.035h-25.381a.709.709,0,0,1-.283-.058.527.527,0,0,1-.328-.408.147.147,0,0,1,0-.023v-1.391a.382.382,0,0,1,.005-.05.6.6,0,0,1,.608-.439h25.382a.714.714,0,0,1,.108.008.691.691,0,0,1,.113.026.63.63,0,0,1,.289.193A.458.458,0,0,1,1755.07,1564.4Z",
    transform: "translate(-1612.376 -1442.921)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M1742.607,1566.212h-13.6a.57.57,0,0,1-.252-.058.517.517,0,0,1-.292-.408.146.146,0,0,1,0-.023v-1.391a.384.384,0,0,1,.005-.05.421.421,0,0,1,.015-.056.542.542,0,0,1,.527-.387h11.929a4.37,4.37,0,0,0,.368.928,4.063,4.063,0,0,0,1.217,1.387Z",
    transform: "translate(-1612.376 -1442.883)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    width: 0.288,
    height: 2.37,
    transform: "translate(139.317 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.341 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 0.288,
    height: 2.37,
    transform: "translate(137.17 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 0.288,
    height: 2.37,
    transform: "translate(135.375 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 0.288,
    height: 2.37,
    transform: "translate(133.477 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 0.288,
    height: 2.37,
    transform: "translate(130.567 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    width: 0.288,
    height: 2.37,
    transform: "translate(127.843 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 0.288,
    height: 2.37,
    transform: "translate(125.41 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.247 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.861 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_325",
    "data-name": "Rectangle 325",
    width: 0.288,
    height: 2.37,
    transform: "translate(141.454 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M2062.488,1563.908v2.353a.628.628,0,0,1-.108.009h-.18V1563.9h.18A.682.682,0,0,1,2062.488,1563.908Z",
    transform: "translate(-1920.3 -1442.939)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M2067.678,1564.523v1.914a.607.607,0,0,1-.288.193v-2.3A.615.615,0,0,1,2067.678,1564.523Z",
    transform: "translate(-1925.089 -1443.336)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M1762.909,1533.779v1.338a.452.452,0,0,1-.105.288.539.539,0,0,1-.058.061.6.6,0,0,1-.232.132.674.674,0,0,1-.113.026c-.018,0-.036,0-.053.006h-25.434a.592.592,0,0,1-.608-.439.335.335,0,0,1-.005-.049v-1.392a.46.46,0,0,1,0-.046.577.577,0,0,1,.536-.439.6.6,0,0,1,.073,0H1762.3a.688.688,0,0,1,.108.008.674.674,0,0,1,.113.026.613.613,0,0,1,.288.193A.452.452,0,0,1,1762.909,1533.779Z",
    transform: "translate(-1619.607 -1414.673)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M1750.446,1535.652h-13.6a.542.542,0,0,1-.527-.382.482.482,0,0,1-.015-.056.338.338,0,0,1-.005-.05v-1.391c0-.016,0-.031,0-.047a.542.542,0,0,1,.478-.439.432.432,0,0,1,.064,0h11.929a4.453,4.453,0,0,0,.3.791A4.063,4.063,0,0,0,1750.446,1535.652Z",
    transform: "translate(-1619.607 -1414.692)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_326",
    "data-name": "Rectangle 326",
    width: 0.288,
    height: 2.37,
    transform: "translate(139.925 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_327",
    "data-name": "Rectangle 327",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.949 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 0.288,
    height: 2.37,
    transform: "translate(137.778 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_329",
    "data-name": "Rectangle 329",
    width: 0.288,
    height: 2.37,
    transform: "translate(135.983 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_330",
    "data-name": "Rectangle 330",
    width: 0.288,
    height: 2.37,
    transform: "translate(134.085 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_331",
    "data-name": "Rectangle 331",
    width: 0.288,
    height: 2.37,
    transform: "translate(131.175 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_332",
    "data-name": "Rectangle 332",
    width: 0.288,
    height: 2.37,
    transform: "translate(128.45 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_333",
    "data-name": "Rectangle 333",
    width: 0.288,
    height: 2.37,
    transform: "translate(126.018 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.855 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_335",
    "data-name": "Rectangle 335",
    width: 0.288,
    height: 2.37,
    transform: "translate(141.469 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_336",
    "data-name": "Rectangle 336",
    width: 0.288,
    height: 2.37,
    transform: "translate(142.062 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M2070.348,1533.259v2.353a.7.7,0,0,1-.108.008h-.18v-2.369h.18A.7.7,0,0,1,2070.348,1533.259Z",
    transform: "translate(-1927.552 -1414.66)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M2075.568,1533.893v1.914a.615.615,0,0,1-.288.193v-2.3A.609.609,0,0,1,2075.568,1533.893Z",
    transform: "translate(-1932.369 -1415.075)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M1738.78,1503.172v1.338a.453.453,0,0,1-.1.288.663.663,0,0,1-.4.22l-.036,0h-25.455a.592.592,0,0,1-.608-.438.4.4,0,0,1-.005-.051v-1.392a.16.16,0,0,0,0-.022.558.558,0,0,1,.464-.451h.018a.771.771,0,0,1,.133-.011h25.49a.765.765,0,0,1,.112.027.6.6,0,0,1,.289.193A.453.453,0,0,1,1738.78,1503.172Z",
    transform: "translate(-1597.343 -1386.432)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M1726.316,1504.984h-13.6a.541.541,0,0,1-.527-.387.462.462,0,0,1-.015-.056.422.422,0,0,1-.005-.051V1503.1a.213.213,0,0,0,0-.022.53.53,0,0,1,.426-.454l.023-.005a.658.658,0,0,1,.1-.007h11.928a.021.021,0,0,0,.005.016,4.146,4.146,0,0,0,1.659,2.349Z",
    transform: "translate(-1597.344 -1386.39)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_337",
    "data-name": "Rectangle 337",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.06 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_338",
    "data-name": "Rectangle 338",
    width: 0.288,
    height: 2.37,
    transform: "translate(137.083 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_339",
    "data-name": "Rectangle 339",
    width: 0.288,
    height: 2.37,
    transform: "translate(135.912 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_340",
    "data-name": "Rectangle 340",
    width: 0.288,
    height: 2.37,
    transform: "translate(134.117 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_341",
    "data-name": "Rectangle 341",
    width: 0.288,
    height: 2.37,
    transform: "translate(132.219 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 0.288,
    height: 2.37,
    transform: "translate(129.309 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343",
    width: 0.288,
    height: 2.37,
    transform: "translate(126.585 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344",
    width: 0.288,
    height: 2.37,
    transform: "translate(124.152 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_345",
    "data-name": "Rectangle 345",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.989 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_346",
    "data-name": "Rectangle 346",
    width: 0.288,
    height: 2.37,
    transform: "translate(139.603 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.196 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M2046.229,1502.668v2.353a.714.714,0,0,1-.108.008h-.18v-2.37h.18A.747.747,0,0,1,2046.229,1502.668Z",
    transform: "translate(-1905.298 -1386.436)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M2051.408,1503.3v1.914a.619.619,0,0,1-.288.193v-2.3A.62.62,0,0,1,2051.408,1503.3Z",
    transform: "translate(-1910.077 -1386.851)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M1738.1,1472.7v1.338a.456.456,0,0,1-.1.289.608.608,0,0,1-.288.192.631.631,0,0,1-.088.023h-.024a.685.685,0,0,1-.107.009h-25.383a.711.711,0,0,1-.077,0,.12.12,0,0,1-.03,0,.57.57,0,0,1-.5-.435.141.141,0,0,0,0-.044c0-.015,0-.018,0-.027v-1.364a.385.385,0,0,1,.006-.05.594.594,0,0,1,.609-.439H1737.6a.643.643,0,0,1,.113.026l.016.005.015.005.012.005.019.007h0l.014.007a.633.633,0,0,1,.119.077.219.219,0,0,1,.029.025c.009.008.019.016.027.025l.012.012c.009.009.015.018.023.026A.455.455,0,0,1,1738.1,1472.7Z",
    transform: "translate(-1596.719 -1358.317)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M1725.6,1474.618h-13.665a.536.536,0,0,1-.476-.441.14.14,0,0,0,0-.044c0-.015,0-.018,0-.027v-1.364a.348.348,0,0,1,.005-.05.207.207,0,0,1,.015-.056.541.541,0,0,1,.528-.387h11.927c.006.019.011.039.017.058a4.148,4.148,0,0,0,1.63,2.3A.186.186,0,0,1,1725.6,1474.618Z",
    transform: "translate(-1596.682 -1358.377)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_348",
    "data-name": "Rectangle 348",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.006 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_349",
    "data-name": "Rectangle 349",
    width: 0.288,
    height: 2.37,
    transform: "translate(137.029 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_350",
    "data-name": "Rectangle 350",
    width: 0.288,
    height: 2.37,
    transform: "translate(135.858 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_351",
    "data-name": "Rectangle 351",
    width: 0.288,
    height: 2.37,
    transform: "translate(134.063 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 0.288,
    height: 2.37,
    transform: "translate(132.165 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 0.288,
    height: 2.37,
    transform: "translate(129.255 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_354",
    "data-name": "Rectangle 354",
    width: 0.288,
    height: 2.37,
    transform: "translate(126.531 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    "data-name": "Rectangle 355",
    width: 0.288,
    height: 2.37,
    transform: "translate(124.099 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.935 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    "data-name": "Rectangle 357",
    width: 0.288,
    height: 2.37,
    transform: "translate(139.549 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    "data-name": "Rectangle 358",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.143 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M2045.559,1472.248v2.353a.748.748,0,0,1-.108.009h-.18v-2.37h.18A.748.748,0,0,1,2045.559,1472.248Z",
    transform: "translate(-1904.68 -1358.369)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M2050.719,1472.883v1.913a.609.609,0,0,1-.289.193v-2.3A.621.621,0,0,1,2050.719,1472.883Z",
    transform: "translate(-1909.441 -1358.784)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M1755.069,1442.846v1.338a.451.451,0,0,1-.1.287.617.617,0,0,1-.288.193.675.675,0,0,1-.113.026c-.018,0-.035,0-.053.006h-25.437a.693.693,0,0,1-.283-.058.526.526,0,0,1-.328-.408.113.113,0,0,1,0-.023v-1.389a.371.371,0,0,1,.005-.049.594.594,0,0,1,.608-.439h25.382a.687.687,0,0,1,.108.008.665.665,0,0,1,.113.027.62.62,0,0,1,.288.193A.453.453,0,0,1,1755.069,1442.846Z",
    transform: "translate(-1612.375 -1330.772)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M1742.606,1444.655h-13.6a.562.562,0,0,1-.252-.058.516.516,0,0,1-.293-.408.15.15,0,0,1,0-.023v-1.394a.419.419,0,0,1,.005-.049.473.473,0,0,1,.015-.056.541.541,0,0,1,.527-.387h11.929a4.155,4.155,0,0,0,1.586,2.31A.693.693,0,0,0,1742.606,1444.655Z",
    transform: "translate(-1612.375 -1330.725)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_359",
    "data-name": "Rectangle 359",
    width: 0.288,
    height: 2.37,
    transform: "translate(139.317 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.341 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 0.288,
    height: 2.37,
    transform: "translate(137.17 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_362",
    "data-name": "Rectangle 362",
    width: 0.288,
    height: 2.37,
    transform: "translate(135.375 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 0.288,
    height: 2.37,
    transform: "translate(133.477 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 0.288,
    height: 2.37,
    transform: "translate(130.567 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 0.288,
    height: 2.37,
    transform: "translate(127.843 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 0.288,
    height: 2.37,
    transform: "translate(125.41 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.247 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.861 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 0.288,
    height: 2.37,
    transform: "translate(141.454 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M2062.488,1442.368v2.353a.682.682,0,0,1-.108.009h-.18v-2.37h.18a.716.716,0,0,1,.108.009Z",
    transform: "translate(-1920.3 -1330.8)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M2067.678,1443v1.913a.609.609,0,0,1-.288.193v-2.3A.613.613,0,0,1,2067.678,1443Z",
    transform: "translate(-1925.089 -1331.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M1781.86,1412.283v1.338a.453.453,0,0,1-.1.287c-.01.011-.018.022-.028.032a.605.605,0,0,1-.26.162.7.7,0,0,1-.112.027.832.832,0,0,1-.109.009h-25.382a.591.591,0,0,1-.608-.44.26.26,0,0,1-.006-.05v-1.391a.569.569,0,0,1,.542-.486h25.459a.721.721,0,0,1,.109.008.678.678,0,0,1,.112.027.619.619,0,0,1,.26.161c.01.01.019.021.028.032A.454.454,0,0,1,1781.86,1412.283Z",
    transform: "translate(-1637.091 -1302.576)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M1769.4,1414.09h-13.6a.542.542,0,0,1-.527-.387.352.352,0,0,1-.015-.056.261.261,0,0,1-.006-.05v-1.391a.43.43,0,0,1,.011-.069.542.542,0,0,1,.472-.417.64.64,0,0,1,.065,0h11.929A4.156,4.156,0,0,0,1769.4,1414.09Z",
    transform: "translate(-1637.091 -1302.529)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    width: 0.288,
    height: 2.37,
    transform: "translate(141.392 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.415 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 0.288,
    height: 2.37,
    transform: "translate(139.244 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    "data-name": "Rectangle 373",
    width: 0.288,
    height: 2.37,
    transform: "translate(137.449 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_374",
    "data-name": "Rectangle 374",
    width: 0.288,
    height: 2.37,
    transform: "translate(135.551 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 0.288,
    height: 2.37,
    transform: "translate(132.642 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_376",
    "data-name": "Rectangle 376",
    width: 0.288,
    height: 2.37,
    transform: "translate(129.917 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_377",
    "data-name": "Rectangle 377",
    width: 0.288,
    height: 2.37,
    transform: "translate(127.484 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_378",
    "data-name": "Rectangle 378",
    width: 0.288,
    height: 2.37,
    transform: "translate(142.321 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_379",
    "data-name": "Rectangle 379",
    width: 0.288,
    height: 2.37,
    transform: "translate(142.936 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_380",
    "data-name": "Rectangle 380",
    width: 0.288,
    height: 2.37,
    transform: "translate(143.528 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M2089.29,1411.738v2.354a.717.717,0,0,1-.108.008H2089v-2.369h.18A.707.707,0,0,1,2089.29,1411.738Z",
    transform: "translate(-1945.027 -1302.539)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M2094.489,1412.373v1.914a.608.608,0,0,1-.289.193v-2.3A.608.608,0,0,1,2094.489,1412.373Z",
    transform: "translate(-1949.825 -1302.954)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M1738.78,1381.6v1.338a.454.454,0,0,1-.1.288.611.611,0,0,1-.289.193.639.639,0,0,1-.112.026.094.094,0,0,0-.036,0h-25.455a.591.591,0,0,1-.608-.439.317.317,0,0,1-.006-.05v-1.392a.364.364,0,0,1,.006-.051.594.594,0,0,1,.608-.438h25.447l.044.006a.607.607,0,0,1,.112.026l.043.016h.009a.608.608,0,0,1,.232.172A.457.457,0,0,1,1738.78,1381.6Z",
    transform: "translate(-1597.343 -1274.259)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M1726.316,1383.49h-13.6a.541.541,0,0,1-.527-.382.457.457,0,0,1-.015-.056.332.332,0,0,1-.005-.05v-1.392a.4.4,0,0,1,.005-.051.473.473,0,0,1,.015-.056.542.542,0,0,1,.528-.383h11.928c.005.018.01.036.015.055a4.148,4.148,0,0,0,1.649,2.311Z",
    transform: "translate(-1597.344 -1274.296)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_381",
    "data-name": "Rectangle 381",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.06 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 0.288,
    height: 2.37,
    transform: "translate(137.083 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    width: 0.288,
    height: 2.37,
    transform: "translate(135.912 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    width: 0.288,
    height: 2.37,
    transform: "translate(134.117 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_385",
    "data-name": "Rectangle 385",
    width: 0.288,
    height: 2.37,
    transform: "translate(132.219 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_386",
    "data-name": "Rectangle 386",
    width: 0.288,
    height: 2.37,
    transform: "translate(129.309 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_387",
    "data-name": "Rectangle 387",
    width: 0.288,
    height: 2.37,
    transform: "translate(126.585 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_388",
    "data-name": "Rectangle 388",
    width: 0.288,
    height: 2.37,
    transform: "translate(124.152 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_389",
    "data-name": "Rectangle 389",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.989 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_390",
    "data-name": "Rectangle 390",
    width: 0.288,
    height: 2.37,
    transform: "translate(139.603 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_391",
    "data-name": "Rectangle 391",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.196 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M2046.229,1381.148v2.353a.715.715,0,0,1-.108.008h-.18v-2.369h.18A.714.714,0,0,1,2046.229,1381.148Z",
    transform: "translate(-1905.298 -1274.315)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M2051.408,1381.783v1.914a.619.619,0,0,1-.288.193v-2.3A.615.615,0,0,1,2051.408,1381.783Z",
    transform: "translate(-1910.077 -1274.73)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M1762.924,1351.763v1.338a.453.453,0,0,1-.105.288.614.614,0,0,1-.288.193.666.666,0,0,1-.113.026.706.706,0,0,1-.108.009h-25.382a.711.711,0,0,1-.275-.055.541.541,0,0,1-.333-.381.272.272,0,0,1,0-.033c0-.007,0-.014,0-.021v-1.391c0-.016,0-.031,0-.047a.578.578,0,0,1,.536-.439h25.522l.04.005a.61.61,0,0,1,.113.026.62.62,0,0,1,.288.193A.454.454,0,0,1,1762.924,1351.763Z",
    transform: "translate(-1619.621 -1246.736)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M1750.46,1353.606h-13.6a.565.565,0,0,1-.244-.055.522.522,0,0,1-.3-.38.282.282,0,0,1,0-.033c0-.007,0-.014,0-.021v-1.391c0-.016,0-.032,0-.047a.541.541,0,0,1,.478-.439.623.623,0,0,1,.064,0h11.928a4.158,4.158,0,0,0,1.591,2.312Z",
    transform: "translate(-1619.621 -1246.726)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_392",
    "data-name": "Rectangle 392",
    width: 0.288,
    height: 2.37,
    transform: "translate(139.925 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_393",
    "data-name": "Rectangle 393",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.949 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 0.288,
    height: 2.37,
    transform: "translate(137.778 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 0.288,
    height: 2.37,
    transform: "translate(135.983 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 0.288,
    height: 2.37,
    transform: "translate(134.085 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 0.288,
    height: 2.37,
    transform: "translate(131.175 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_398",
    "data-name": "Rectangle 398",
    width: 0.288,
    height: 2.37,
    transform: "translate(128.45 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_399",
    "data-name": "Rectangle 399",
    width: 0.288,
    height: 2.37,
    transform: "translate(126.018 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_400",
    "data-name": "Rectangle 400",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.855 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_401",
    "data-name": "Rectangle 401",
    width: 0.288,
    height: 2.37,
    transform: "translate(141.469 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_402",
    "data-name": "Rectangle 402",
    width: 0.288,
    height: 2.37,
    transform: "translate(142.062 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M2070.348,1351.219v2.353a.7.7,0,0,1-.108.009h-.18v-2.37h.18A.668.668,0,0,1,2070.348,1351.219Z",
    transform: "translate(-1927.552 -1246.7)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M2075.568,1351.853v1.914a.617.617,0,0,1-.288.194v-2.3A.609.609,0,0,1,2075.568,1351.853Z",
    transform: "translate(-1932.369 -1247.115)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M1773.162,1321.126v1.339a.454.454,0,0,1-.106.287.472.472,0,0,1-.058.062.611.611,0,0,1-.232.132.7.7,0,0,1-.112.026l-.035,0h-25.453a.62.62,0,0,1-.067,0,.582.582,0,0,1-.542-.436.373.373,0,0,1-.006-.049V1321.1a.376.376,0,0,1,.006-.05.594.594,0,0,1,.608-.439h25.382a.709.709,0,0,1,.109.008.616.616,0,0,1,.112.027.6.6,0,0,1,.288.193A.455.455,0,0,1,1773.162,1321.126Z",
    transform: "translate(-1629.064 -1218.467)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M1760.706,1323.016h-13.6a.519.519,0,0,1-.542-.436.372.372,0,0,1-.006-.05v-1.392a.367.367,0,0,1,.006-.049.375.375,0,0,1,.015-.057.542.542,0,0,1,.527-.383h11.928a4.155,4.155,0,0,0,1.664,2.365Z",
    transform: "translate(-1629.073 -1218.502)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_403",
    "data-name": "Rectangle 403",
    width: 0.288,
    height: 2.37,
    transform: "translate(140.72 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_404",
    "data-name": "Rectangle 404",
    width: 0.288,
    height: 2.37,
    transform: "translate(139.743 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_405",
    "data-name": "Rectangle 405",
    width: 0.288,
    height: 2.37,
    transform: "translate(138.572 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_406",
    "data-name": "Rectangle 406",
    width: 0.288,
    height: 2.37,
    transform: "translate(136.777 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    width: 0.288,
    height: 2.37,
    transform: "translate(134.879 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    width: 0.288,
    height: 2.37,
    transform: "translate(131.969 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_409",
    "data-name": "Rectangle 409",
    width: 0.288,
    height: 2.37,
    transform: "translate(129.245 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_410",
    "data-name": "Rectangle 410",
    width: 0.288,
    height: 2.37,
    transform: "translate(126.812 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    width: 0.288,
    height: 2.37,
    transform: "translate(141.649 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_412",
    "data-name": "Rectangle 412",
    width: 0.288,
    height: 2.37,
    transform: "translate(142.263 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    width: 0.288,
    height: 2.37,
    transform: "translate(142.857 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M2080.618,1320.628v2.353a.7.7,0,0,1-.108.008h-.18v-2.37h.18A.7.7,0,0,1,2080.618,1320.628Z",
    transform: "translate(-1937.028 -1218.476)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M2085.808,1321.263v1.913a.612.612,0,0,1-.288.193v-2.3A.615.615,0,0,1,2085.808,1321.263Z",
    transform: "translate(-1941.816 -1218.891)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M738.675,1624.916v1.338a.453.453,0,0,1-.105.288.607.607,0,0,1-.289.193.631.631,0,0,1-.112.026.73.73,0,0,1-.108.009H712.683a.58.58,0,0,1-.613-.49v-1.391a.58.58,0,0,1,.613-.49h25.382a.729.729,0,0,1,.108.008.654.654,0,0,1,.112.026.613.613,0,0,1,.289.194.454.454,0,0,1,.1.288Z",
    transform: "translate(-674.597 -1498.76)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M726.165,1626.728h-13.6a.537.537,0,0,1-.547-.49v-1.391a.537.537,0,0,1,.547-.49H724.5a4.161,4.161,0,0,0,1.67,2.37Z",
    transform: "translate(-674.551 -1498.721)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.702 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 0.288,
    height: 2.37,
    transform: "translate(59.725 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 0.288,
    height: 2.37,
    transform: "translate(58.554 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 0.288,
    height: 2.37,
    transform: "translate(56.759 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 0.288,
    height: 2.37,
    transform: "translate(54.861 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    width: 0.288,
    height: 2.37,
    transform: "translate(51.952 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    "data-name": "Rectangle 420",
    width: 0.288,
    height: 2.37,
    transform: "translate(49.227 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 0.288,
    height: 2.37,
    transform: "translate(46.794 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 0.288,
    height: 2.37,
    transform: "translate(61.631 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 0.288,
    height: 2.37,
    transform: "translate(62.245 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 0.288,
    height: 2.37,
    transform: "translate(62.838 125.64)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M1046.068,1624.408v2.353a.731.731,0,0,1-.108.009h-.18v-2.37h.18a.731.731,0,0,1,.108.008Z",
    transform: "translate(-982.496 -1498.76)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M1051.248,1625.044v1.913a.608.608,0,0,1-.288.193v-2.3A.61.61,0,0,1,1051.248,1625.044Z",
    transform: "translate(-987.275 -1499.175)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M703.542,1594.285v1.339a.458.458,0,0,1-.105.288.605.605,0,0,1-.288.192.689.689,0,0,1-.113.027.7.7,0,0,1-.108.008H677.543a.579.579,0,0,1-.613-.489v-1.392a.579.579,0,0,1,.613-.489h25.489a.69.69,0,0,1,.113.027l.016.005.016.005.03.012.018.009.016.008.029.015.032.019.023.016h0l.015.011a.416.416,0,0,1,.045.039l.012.012.012.012.022.026A.457.457,0,0,1,703.542,1594.285Z",
    transform: "translate(-642.175 -1470.499)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M691.066,1596.137h-13.6a.536.536,0,0,1-.548-.489v-1.391a.536.536,0,0,1,.548-.489H689.4c.005.019.011.039.017.058A4.148,4.148,0,0,0,691.066,1596.137Z",
    transform: "translate(-642.165 -1470.497)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 0.288,
    height: 2.37,
    transform: "translate(57.988 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 0.288,
    height: 2.37,
    transform: "translate(57.011 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 0.288,
    height: 2.37,
    transform: "translate(55.84 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 0.288,
    height: 2.37,
    transform: "translate(54.045 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    width: 0.288,
    height: 2.37,
    transform: "translate(52.147 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    width: 0.288,
    height: 2.37,
    transform: "translate(49.237 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    width: 0.288,
    height: 2.37,
    transform: "translate(46.513 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 0.288,
    height: 2.37,
    transform: "translate(44.08 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 0.288,
    height: 2.37,
    transform: "translate(58.917 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 0.288,
    height: 2.37,
    transform: "translate(59.531 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.125 123.271)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M1010.978,1593.778v2.353a.618.618,0,0,1-.108.008h-.18v-2.369h.179A.689.689,0,0,1,1010.978,1593.778Z",
    transform: "translate(-950.12 -1470.499)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M1016.168,1594.412v1.914a.608.608,0,0,1-.288.193v-2.3A.608.608,0,0,1,1016.168,1594.412Z",
    transform: "translate(-954.908 -1470.914)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M720.518,1564.4v1.338a.457.457,0,0,1-.105.288.614.614,0,0,1-.289.193.644.644,0,0,1-.112.027.714.714,0,0,1-.108.008H694.521a.708.708,0,0,1-.283-.058.526.526,0,0,1-.328-.408v-1.415a.58.58,0,0,1,.613-.489h25.382a.7.7,0,0,1,.108.008.648.648,0,0,1,.112.027.613.613,0,0,1,.288.193A.457.457,0,0,1,720.518,1564.4Z",
    transform: "translate(-657.841 -1442.921)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M708.09,1566.248H694.5a.575.575,0,0,1-.252-.058.517.517,0,0,1-.293-.408v-1.415a.537.537,0,0,1,.548-.489H706.42a4.163,4.163,0,0,0,1.586,2.311Z",
    transform: "translate(-657.878 -1442.919)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 0.288,
    height: 2.37,
    transform: "translate(59.299 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 0.288,
    height: 2.37,
    transform: "translate(58.322 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 0.288,
    height: 2.37,
    transform: "translate(57.151 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 0.288,
    height: 2.37,
    transform: "translate(55.357 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 0.288,
    height: 2.37,
    transform: "translate(53.459 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 0.288,
    height: 2.37,
    transform: "translate(50.549 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 0.288,
    height: 2.37,
    transform: "translate(47.824 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 0.288,
    height: 2.37,
    transform: "translate(45.392 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.229 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.842 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 0.288,
    height: 2.37,
    transform: "translate(61.436 120.96)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M1027.938,1563.908v2.353a.631.631,0,0,1-.108.008h-.18V1563.9h.182A.7.7,0,0,1,1027.938,1563.908Z",
    transform: "translate(-965.768 -1442.939)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M1033.119,1564.523v1.914a.61.61,0,0,1-.288.193v-2.3A.618.618,0,0,1,1033.119,1564.523Z",
    transform: "translate(-970.547 -1443.336)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M728.35,1533.779v1.338a.455.455,0,0,1-.105.288.613.613,0,0,1-.289.193.666.666,0,0,1-.112.026.729.729,0,0,1-.108.008H702.354a.581.581,0,0,1-.614-.49v-1.392a.567.567,0,0,1,.541-.486.6.6,0,0,1,.073,0h25.382a.729.729,0,0,1,.108.008.6.6,0,0,1,.112.026.607.607,0,0,1,.289.193A.455.455,0,0,1,728.35,1533.779Z",
    transform: "translate(-665.066 -1414.673)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M715.886,1535.633h-13.6a.541.541,0,0,1-.548-.49v-1.392a.533.533,0,0,1,.483-.486.471.471,0,0,1,.064,0h11.925A4.156,4.156,0,0,0,715.886,1535.633Z",
    transform: "translate(-665.066 -1414.673)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 0.288,
    height: 2.37,
    transform: "translate(59.907 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 0.288,
    height: 2.37,
    transform: "translate(58.93 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 0.288,
    height: 2.37,
    transform: "translate(57.759 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 0.288,
    height: 2.37,
    transform: "translate(55.965 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 0.288,
    height: 2.37,
    transform: "translate(54.067 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 0.288,
    height: 2.37,
    transform: "translate(51.157 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 0.288,
    height: 2.37,
    transform: "translate(48.432 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 0.288,
    height: 2.37,
    transform: "translate(46 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.837 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    width: 0.288,
    height: 2.37,
    transform: "translate(61.451 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    "data-name": "Rectangle 457",
    width: 0.288,
    height: 2.37,
    transform: "translate(62.044 118.59)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M1035.8,1533.259v2.353a.716.716,0,0,1-.108.008h-.18v-2.369h.18A.716.716,0,0,1,1035.8,1533.259Z",
    transform: "translate(-973.02 -1414.66)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M1040.979,1533.893v1.914a.613.613,0,0,1-.288.193v-2.3A.607.607,0,0,1,1040.979,1533.893Z",
    transform: "translate(-977.799 -1415.075)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M704.226,1503.176v1.338a.454.454,0,0,1-.105.288.615.615,0,0,1-.288.193.7.7,0,0,1-.113.026.1.1,0,0,0-.036,0H678.23a.58.58,0,0,1-.613-.49v-1.391a.213.213,0,0,1,0-.022.556.556,0,0,1,.464-.452h.018a.784.784,0,0,1,.133-.012h25.49a.7.7,0,0,1,.113.026.614.614,0,0,1,.288.193A.454.454,0,0,1,704.226,1503.176Z",
    transform: "translate(-642.808 -1386.436)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M691.762,1505.03h-13.6a.537.537,0,0,1-.548-.49v-1.391a.213.213,0,0,1,0-.022.529.529,0,0,1,.425-.455l.023,0a.593.593,0,0,1,.1-.009h11.93l0,.017a4.152,4.152,0,0,0,1.66,2.349Z",
    transform: "translate(-642.808 -1386.436)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    "data-name": "Rectangle 458",
    width: 0.288,
    height: 2.37,
    transform: "translate(58.041 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 0.288,
    height: 2.37,
    transform: "translate(57.065 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 0.288,
    height: 2.37,
    transform: "translate(55.894 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    "data-name": "Rectangle 461",
    width: 0.288,
    height: 2.37,
    transform: "translate(54.099 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 0.288,
    height: 2.37,
    transform: "translate(52.201 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    width: 0.288,
    height: 2.37,
    transform: "translate(49.291 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 0.288,
    height: 2.37,
    transform: "translate(46.567 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 0.288,
    height: 2.37,
    transform: "translate(44.133 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    width: 0.288,
    height: 2.37,
    transform: "translate(58.971 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    width: 0.288,
    height: 2.37,
    transform: "translate(59.585 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.178 116.224)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M1011.668,1502.668v2.353a.714.714,0,0,1-.108.008h-.18v-2.37h.18A.73.73,0,0,1,1011.668,1502.668Z",
    transform: "translate(-950.756 -1386.436)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M1016.858,1503.3v1.914a.614.614,0,0,1-.288.193v-2.3A.611.611,0,0,1,1016.858,1503.3Z",
    transform: "translate(-955.545 -1386.851)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M703.57,1472.752v1.338a.455.455,0,0,1-.105.288.6.6,0,0,1-.288.193.687.687,0,0,1-.088.022h-.025a.731.731,0,0,1-.108.009H677.571a.712.712,0,0,1-.077,0h-.03a.558.558,0,0,1-.5-.481v-1.391a.58.58,0,0,1,.613-.49H703.06a.664.664,0,0,1,.113.026l.015.005.016.006.03.012.033.016.029.015.032.02.023.016h0l.015.012a.491.491,0,0,1,.045.038l.012.012.012.012c.008.009.016.017.022.026A.454.454,0,0,1,703.57,1472.752Z",
    transform: "translate(-642.202 -1358.365)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M691.076,1474.654H677.41a.531.531,0,0,1-.48-.486v-1.391a.537.537,0,0,1,.548-.49H689.4c.006.019.011.039.017.059a4.146,4.146,0,0,0,1.629,2.294Z",
    transform: "translate(-642.175 -1358.413)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 0.288,
    height: 2.37,
    transform: "translate(57.988 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_470",
    "data-name": "Rectangle 470",
    width: 0.288,
    height: 2.37,
    transform: "translate(57.011 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 0.288,
    height: 2.37,
    transform: "translate(55.84 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 0.288,
    height: 2.37,
    transform: "translate(54.045 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_473",
    "data-name": "Rectangle 473",
    width: 0.288,
    height: 2.37,
    transform: "translate(52.147 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    width: 0.288,
    height: 2.37,
    transform: "translate(49.237 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_475",
    "data-name": "Rectangle 475",
    width: 0.288,
    height: 2.37,
    transform: "translate(46.513 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 0.288,
    height: 2.37,
    transform: "translate(44.08 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 0.288,
    height: 2.37,
    transform: "translate(58.917 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 0.288,
    height: 2.37,
    transform: "translate(59.531 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.125 113.871)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M1010.978,1472.248v2.353a.7.7,0,0,1-.108.009h-.18v-2.37h.179A.718.718,0,0,1,1010.978,1472.248Z",
    transform: "translate(-950.12 -1358.369)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M1016.168,1472.883v1.913a.6.6,0,0,1-.288.193v-2.3A.612.612,0,0,1,1016.168,1472.883Z",
    transform: "translate(-954.908 -1358.784)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M720.518,1442.827v1.338a.453.453,0,0,1-.105.288.62.62,0,0,1-.289.194.666.666,0,0,1-.112.026.715.715,0,0,1-.108.009H694.521a.7.7,0,0,1-.283-.059.526.526,0,0,1-.328-.408V1442.8a.58.58,0,0,1,.613-.49H719.9a.731.731,0,0,1,.108.009.668.668,0,0,1,.112.026.62.62,0,0,1,.289.193A.454.454,0,0,1,720.518,1442.827Z",
    transform: "translate(-657.841 -1330.753)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M708.09,1444.71H694.5a.56.56,0,0,1-.252-.059.516.516,0,0,1-.293-.408v-1.415a.541.541,0,0,1,.548-.49H706.42a4.159,4.159,0,0,0,1.586,2.311Z",
    transform: "translate(-657.878 -1330.78)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 0.288,
    height: 2.37,
    transform: "translate(59.299 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 0.288,
    height: 2.37,
    transform: "translate(58.322 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 0.288,
    height: 2.37,
    transform: "translate(57.151 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 0.288,
    height: 2.37,
    transform: "translate(55.357 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 0.288,
    height: 2.37,
    transform: "translate(53.459 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 0.288,
    height: 2.37,
    transform: "translate(50.549 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 0.288,
    height: 2.37,
    transform: "translate(47.824 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 0.288,
    height: 2.37,
    transform: "translate(45.392 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_488",
    "data-name": "Rectangle 488",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.229 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_489",
    "data-name": "Rectangle 489",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.842 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    "data-name": "Rectangle 490",
    width: 0.288,
    height: 2.37,
    transform: "translate(61.436 111.56)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M1027.938,1442.368v2.353a.685.685,0,0,1-.108.009h-.18v-2.37h.182A.727.727,0,0,1,1027.938,1442.368Z",
    transform: "translate(-965.768 -1330.8)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M1033.119,1443v1.913a.612.612,0,0,1-.288.193v-2.3A.62.62,0,0,1,1033.119,1443Z",
    transform: "translate(-970.547 -1331.215)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M747.31,1412.282v1.339a.456.456,0,0,1-.105.288.614.614,0,0,1-.288.193.679.679,0,0,1-.112.027.729.729,0,0,1-.108.008H721.313a.58.58,0,0,1-.613-.489v-1.391a.567.567,0,0,1,.541-.486H746.7a.713.713,0,0,1,.108.008.667.667,0,0,1,.112.027.612.612,0,0,1,.288.193A.456.456,0,0,1,747.31,1412.282Z",
    transform: "translate(-682.559 -1302.576)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M734.846,1414.125h-13.6a.537.537,0,0,1-.548-.489v-1.391a.533.533,0,0,1,.483-.486.64.64,0,0,1,.065,0h11.928A4.154,4.154,0,0,0,734.846,1414.125Z",
    transform: "translate(-682.559 -1302.565)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_491",
    "data-name": "Rectangle 491",
    width: 0.288,
    height: 2.37,
    transform: "translate(61.374 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_492",
    "data-name": "Rectangle 492",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.397 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 0.288,
    height: 2.37,
    transform: "translate(59.226 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 0.288,
    height: 2.37,
    transform: "translate(57.431 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495",
    "data-name": "Rectangle 495",
    width: 0.288,
    height: 2.37,
    transform: "translate(55.533 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496",
    "data-name": "Rectangle 496",
    width: 0.288,
    height: 2.37,
    transform: "translate(52.623 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    width: 0.288,
    height: 2.37,
    transform: "translate(49.899 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 0.288,
    height: 2.37,
    transform: "translate(47.466 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 0.288,
    height: 2.37,
    transform: "translate(62.303 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 0.288,
    height: 2.37,
    transform: "translate(62.917 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501",
    "data-name": "Rectangle 501",
    width: 0.288,
    height: 2.37,
    transform: "translate(63.51 109.191)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M1054.758,1411.738v2.354a.7.7,0,0,1-.108.008h-.18v-2.369h.18A.7.7,0,0,1,1054.758,1411.738Z",
    transform: "translate(-990.513 -1302.539)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M1059.938,1412.373v1.914a.614.614,0,0,1-.289.193v-2.3A.614.614,0,0,1,1059.938,1412.373Z",
    transform: "translate(-995.293 -1302.954)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M704.229,1381.619v1.338a.455.455,0,0,1-.105.288.613.613,0,0,1-.288.193.777.777,0,0,1-.113.026l-.036,0H678.233a.579.579,0,0,1-.613-.489v-1.391a.579.579,0,0,1,.613-.489h25.414a.752.752,0,0,1,.19.034.563.563,0,0,1,.053.02l.031.014h0l.031.016h0l.028.017a.5.5,0,0,1,.061.045l.017.015h0l.011.009h0l.019.019.024.028A.459.459,0,0,1,704.229,1381.619Z",
    transform: "translate(-642.811 -1274.278)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M691.766,1383.507h-13.6a.536.536,0,0,1-.548-.489v-1.392a.536.536,0,0,1,.548-.489H690.1c0,.018.009.036.015.055a4.15,4.15,0,0,0,1.649,2.311Z",
    transform: "translate(-642.811 -1274.313)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502",
    "data-name": "Rectangle 502",
    width: 0.288,
    height: 2.37,
    transform: "translate(58.041 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_503",
    "data-name": "Rectangle 503",
    width: 0.288,
    height: 2.37,
    transform: "translate(57.065 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504",
    "data-name": "Rectangle 504",
    width: 0.288,
    height: 2.37,
    transform: "translate(55.894 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_505",
    "data-name": "Rectangle 505",
    width: 0.288,
    height: 2.37,
    transform: "translate(54.099 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506",
    "data-name": "Rectangle 506",
    width: 0.288,
    height: 2.37,
    transform: "translate(52.201 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507",
    "data-name": "Rectangle 507",
    width: 0.288,
    height: 2.37,
    transform: "translate(49.291 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508",
    "data-name": "Rectangle 508",
    width: 0.288,
    height: 2.37,
    transform: "translate(46.567 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509",
    "data-name": "Rectangle 509",
    width: 0.288,
    height: 2.37,
    transform: "translate(44.133 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_510",
    "data-name": "Rectangle 510",
    width: 0.288,
    height: 2.37,
    transform: "translate(58.971 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    width: 0.288,
    height: 2.37,
    transform: "translate(59.585 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_512",
    "data-name": "Rectangle 512",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.178 106.825)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M1011.668,1381.148v2.353a.7.7,0,0,1-.108.008h-.18v-2.369h.18A.714.714,0,0,1,1011.668,1381.148Z",
    transform: "translate(-950.756 -1274.315)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M1016.858,1381.783v1.914a.615.615,0,0,1-.288.193v-2.3A.608.608,0,0,1,1016.858,1381.783Z",
    transform: "translate(-955.545 -1274.73)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M728.378,1351.754v1.338a.455.455,0,0,1-.105.288.613.613,0,0,1-.289.193.656.656,0,0,1-.112.026.715.715,0,0,1-.108.008H702.382a.708.708,0,0,1-.275-.055.528.528,0,0,1-.337-.414v-1.413a.566.566,0,0,1,.542-.486h25.454a.7.7,0,0,1,.108.008.59.59,0,0,1,.112.026.608.608,0,0,1,.289.193A.454.454,0,0,1,728.378,1351.754Z",
    transform: "translate(-665.094 -1246.728)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M715.913,1353.6h-13.6a.571.571,0,0,1-.244-.055.518.518,0,0,1-.3-.414v-1.413a.533.533,0,0,1,.483-.486.626.626,0,0,1,.064,0H714.24a4.156,4.156,0,0,0,1.59,2.311Z",
    transform: "translate(-665.094 -1246.717)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_513",
    "data-name": "Rectangle 513",
    width: 0.288,
    height: 2.37,
    transform: "translate(59.907 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_514",
    "data-name": "Rectangle 514",
    width: 0.288,
    height: 2.37,
    transform: "translate(58.93 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_515",
    "data-name": "Rectangle 515",
    width: 0.288,
    height: 2.37,
    transform: "translate(57.759 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_516",
    "data-name": "Rectangle 516",
    width: 0.288,
    height: 2.37,
    transform: "translate(55.965 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_517",
    "data-name": "Rectangle 517",
    width: 0.288,
    height: 2.37,
    transform: "translate(54.067 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_518",
    "data-name": "Rectangle 518",
    width: 0.288,
    height: 2.37,
    transform: "translate(51.157 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 0.288,
    height: 2.37,
    transform: "translate(48.432 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    width: 0.288,
    height: 2.37,
    transform: "translate(46 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_521",
    "data-name": "Rectangle 521",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.837 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 0.288,
    height: 2.37,
    transform: "translate(61.451 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    width: 0.288,
    height: 2.37,
    transform: "translate(62.044 104.51)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M1035.8,1351.219v2.353a.767.767,0,0,1-.108.009h-.18v-2.37h.18A.7.7,0,0,1,1035.8,1351.219Z",
    transform: "translate(-973.02 -1246.7)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M1040.979,1351.853v1.914a.613.613,0,0,1-.288.194v-2.3A.606.606,0,0,1,1040.979,1351.853Z",
    transform: "translate(-977.799 -1247.115)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M738.675,1321.09v1.338a.454.454,0,0,1-.105.288.611.611,0,0,1-.289.193.653.653,0,0,1-.112.026l-.036,0H712.683a.58.58,0,0,1-.613-.49v-1.391a.58.58,0,0,1,.613-.49h25.382a.713.713,0,0,1,.108.009.654.654,0,0,1,.112.026.611.611,0,0,1,.289.193A.454.454,0,0,1,738.675,1321.09Z",
    transform: "translate(-674.597 -1218.43)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M726.165,1322.988h-13.6a.537.537,0,0,1-.547-.49v-1.391a.537.537,0,0,1,.547-.49h11.927a4.157,4.157,0,0,0,1.665,2.366Z",
    transform: "translate(-674.551 -1218.474)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    width: 0.288,
    height: 2.37,
    transform: "translate(60.702 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 0.288,
    height: 2.37,
    transform: "translate(59.725 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 0.288,
    height: 2.37,
    transform: "translate(58.554 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 0.288,
    height: 2.37,
    transform: "translate(56.759 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 0.288,
    height: 2.37,
    transform: "translate(54.861 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 0.288,
    height: 2.37,
    transform: "translate(51.952 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 0.288,
    height: 2.37,
    transform: "translate(49.227 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 0.288,
    height: 2.37,
    transform: "translate(46.794 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_532",
    "data-name": "Rectangle 532",
    width: 0.288,
    height: 2.37,
    transform: "translate(61.631 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    width: 0.288,
    height: 2.37,
    transform: "translate(62.245 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 0.288,
    height: 2.37,
    transform: "translate(62.838 102.144)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M1046.068,1320.628v2.353a.7.7,0,0,1-.108.008h-.18v-2.37h.18A.715.715,0,0,1,1046.068,1320.628Z",
    transform: "translate(-982.496 -1218.476)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M1051.248,1321.263v1.913a.612.612,0,0,1-.288.193v-2.3A.612.612,0,0,1,1051.248,1321.263Z",
    transform: "translate(-987.275 -1218.891)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1416",
    "data-name": "Ellipse 1416",
    cx: 12.661,
    cy: 12.661,
    r: 12.661,
    transform: "translate(102.091 102.765)",
    fill: "#e2810e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M1726.289,1352q0,.6-.045,1.181h0c-.02.266-.048.53-.082.791a14.769,14.769,0,0,1-.289,1.574c-.077.309-.155.619-.252.928a14.436,14.436,0,0,1-.506,1.387c-.008.019-.016.039-.025.058q-.263.619-.581,1.2t-.671,1.111c-.015.023-.031.046-.047.069-.093.139-.189.275-.288.409a13.348,13.348,0,0,1-1.67,1.891h-7.107a.542.542,0,0,1-.528-.387.393.393,0,0,1-.015-.056.4.4,0,0,1-.006-.051v-1.392a.351.351,0,0,1,.006-.049.364.364,0,0,1,.015-.057.542.542,0,0,1,.528-.382h-2.713a.541.541,0,0,1-.528-.387c-.005-.019-.011-.037-.015-.056a.348.348,0,0,1-.005-.05v-1.391a.338.338,0,0,1,.005-.05.213.213,0,0,1,.015-.056.542.542,0,0,1,.528-.387h1.058a.518.518,0,0,1-.292-.408.123.123,0,0,1,0-.023v-1.391a.348.348,0,0,1,.005-.05.417.417,0,0,1,.015-.056.541.541,0,0,1,.527-.387h.608a.542.542,0,0,1-.527-.382.437.437,0,0,1-.015-.057.324.324,0,0,1-.005-.05v-1.391a.4.4,0,0,1,0-.047.541.541,0,0,1,.478-.439h-1.8a.541.541,0,0,1-.528-.387.459.459,0,0,1-.015-.056.393.393,0,0,1-.005-.051v-1.392a.165.165,0,0,0,0-.022.53.53,0,0,1,.426-.454.536.536,0,0,1-.477-.441.141.141,0,0,0,0-.044c0-.015,0-.018,0-.027v-1.364a.364.364,0,0,1,.005-.05.2.2,0,0,1,.015-.056.541.541,0,0,1,.528-.387h1.058a.514.514,0,0,1-.292-.407.113.113,0,0,1,0-.023c0-.008,0-.018,0-.025v-1.347a.333.333,0,0,1,.005-.049.487.487,0,0,1,.015-.057.541.541,0,0,1,.527-.387h2.074a.541.541,0,0,1-.526-.387.332.332,0,0,1-.015-.056.241.241,0,0,1-.006-.05v-1.391a.42.42,0,0,1,.011-.069.541.541,0,0,1,.472-.417h-3.267a.542.542,0,0,1-.528-.382.494.494,0,0,1-.015-.057.378.378,0,0,1-.005-.05v-1.392a.4.4,0,0,1,.005-.051.466.466,0,0,1,.015-.056.541.541,0,0,1,.528-.383h1.624a.522.522,0,0,1-.3-.38.231.231,0,0,1,0-.033.152.152,0,0,1,0-.021v-1.391a.415.415,0,0,1,0-.047.541.541,0,0,1,.478-.439.626.626,0,0,1,.064,0h.735a.534.534,0,0,1-.483-.436.361.361,0,0,1-.006-.05v-.521a11.649,11.649,0,0,1,4.215,1.006h.007a12.506,12.506,0,0,1,3.45,2.312l.06.055a13.591,13.591,0,0,1,1.366,1.516q.148.19.288.387c.094.131.191.271.283.409h0c.111.168.22.339.326.514s.2.329.288.5a14.118,14.118,0,0,1,.656,1.354,14.588,14.588,0,0,1,.756,2.31c0,.019.009.039.014.058.02.084.038.168.056.253a15.048,15.048,0,0,1,.289,1.943c0,.033.005.066.008.1v.016Q1726.289,1351.405,1726.289,1352Z",
    transform: "translate(-1596.691 -1234.585)",
    fill: "#e2810e",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1417",
    "data-name": "Ellipse 1417",
    cx: 12.661,
    cy: 12.661,
    r: 12.661,
    transform: "translate(100.987 102.765)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M1559.292,1368.178a11.536,11.536,0,1,1,8.156-3.379A11.536,11.536,0,0,1,1559.292,1368.178Zm0-22.383a10.847,10.847,0,1,0,10.847,10.848,10.86,10.86,0,0,0-10.847-10.848Z",
    transform: "translate(-1445.645 -1241.067)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M1638.165,1396.006a1.9,1.9,0,0,0-.028-.67,1.383,1.383,0,0,0-.283-.556,2.614,2.614,0,0,0-.566-.5,6.863,6.863,0,0,0-.878-.491,18.159,18.159,0,0,1-1.624-.891,5.732,5.732,0,0,1-1.212-.986,3.364,3.364,0,0,1-.715-1.2,3.812,3.812,0,0,1,.308-2.883,3.206,3.206,0,0,1,.894-.993,4.011,4.011,0,0,1,1.28-.61,5.352,5.352,0,0,1,1.6-.184l.225-1.9,1.531.181-.232,1.928a4.772,4.772,0,0,1,1.44.613,3.615,3.615,0,0,1,1.612,2.313,4.8,4.8,0,0,1,.063,1.634l-2.764-.328a2.35,2.35,0,0,0-.284-1.651,1.623,1.623,0,0,0-1.2-.679,2.067,2.067,0,0,0-.756.032,1.4,1.4,0,0,0-.551.268,1.3,1.3,0,0,0-.355.458,1.927,1.927,0,0,0-.169.6,1.764,1.764,0,0,0,.025.606,1.3,1.3,0,0,0,.272.532,2.615,2.615,0,0,0,.572.5,8.926,8.926,0,0,0,.912.527q.886.456,1.6.911a5.827,5.827,0,0,1,1.206.994,3.614,3.614,0,0,1,.4,4.107,3.161,3.161,0,0,1-.9.983,3.861,3.861,0,0,1-1.287.586,5.757,5.757,0,0,1-1.606.17l-.209,1.768-1.522-.18.209-1.76a6.473,6.473,0,0,1-1.494-.528,4.105,4.105,0,0,1-1.224-.928,3.672,3.672,0,0,1-.768-1.375,4.478,4.478,0,0,1-.127-1.871l2.764.328a2.756,2.756,0,0,0,.052,1.074,1.771,1.771,0,0,0,.394.731,1.714,1.714,0,0,0,.632.435,2.944,2.944,0,0,0,.758.193,2.466,2.466,0,0,0,.8-.022,1.642,1.642,0,0,0,.606-.252,1.322,1.322,0,0,0,.4-.443A1.622,1.622,0,0,0,1638.165,1396.006Z",
    transform: "translate(-1522.929 -1277.083)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1418",
    "data-name": "Ellipse 1418",
    cx: 14.309,
    cy: 14.309,
    r: 14.309,
    transform: "translate(31.245 87.836) rotate(-45)",
    fill: "#e2810e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1419",
    "data-name": "Ellipse 1419",
    cx: 14.309,
    cy: 14.309,
    r: 14.309,
    transform: "translate(29.996 87.835) rotate(-45)",
    fill: "#fcc02e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M721.493,995.3a13.037,13.037,0,1,1,9.22-3.818A13.037,13.037,0,0,1,721.493,995.3Zm0-25.3a12.26,12.26,0,1,0,12.26,12.259A12.273,12.273,0,0,0,721.493,970Z",
    transform: "translate(-671.264 -894.258)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M810.7,1026.751a2.146,2.146,0,0,0-.031-.757,1.577,1.577,0,0,0-.32-.629,2.975,2.975,0,0,0-.64-.565,7.867,7.867,0,0,0-.992-.555,20.668,20.668,0,0,1-1.831-1.005,6.5,6.5,0,0,1-1.37-1.115,3.831,3.831,0,0,1-.809-1.358,4.3,4.3,0,0,1,.349-3.259,3.622,3.622,0,0,1,1.01-1.122,4.52,4.52,0,0,1,1.446-.688,6.048,6.048,0,0,1,1.806-.209l.255-2.149,1.728.206-.259,2.179a5.409,5.409,0,0,1,1.628.691,4.094,4.094,0,0,1,1.822,2.615,5.436,5.436,0,0,1,.071,1.846l-3.122-.371a2.651,2.651,0,0,0-.321-1.866,1.843,1.843,0,0,0-1.362-.767,2.333,2.333,0,0,0-.851.036,1.575,1.575,0,0,0-.619.3,1.481,1.481,0,0,0-.4.517,2.176,2.176,0,0,0-.19.681,1.984,1.984,0,0,0,.029.685,1.469,1.469,0,0,0,.309.6,2.968,2.968,0,0,0,.646.565,10.08,10.08,0,0,0,1.031.6q1,.516,1.812,1.029a6.574,6.574,0,0,1,1.363,1.124,3.684,3.684,0,0,1,.949,3.092,3.928,3.928,0,0,1-.5,1.547,3.585,3.585,0,0,1-1.014,1.111,4.367,4.367,0,0,1-1.455.663,6.5,6.5,0,0,1-1.815.192l-.237,2-1.719-.2.236-1.989a7.292,7.292,0,0,1-1.688-.6,4.631,4.631,0,0,1-1.392-1.042,4.141,4.141,0,0,1-.869-1.554,5.056,5.056,0,0,1-.144-2.115l3.125.37a3.1,3.1,0,0,0,.059,1.214,2.009,2.009,0,0,0,.444.827,1.954,1.954,0,0,0,.715.492,3.369,3.369,0,0,0,.856.219,2.822,2.822,0,0,0,.907-.025,1.867,1.867,0,0,0,.686-.286,1.491,1.491,0,0,0,.455-.5A1.808,1.808,0,0,0,810.7,1026.751Z",
    transform: "translate(-758.677 -934.962)",
    fill: "#ffa412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M1930.574,1113.5s-1.345,1.894-2.578,1.921a9.006,9.006,0,0,1-3.108-.878s-1.132-2.523-.364-3.511a1.647,1.647,0,0,1,1.575.259,2.4,2.4,0,0,1,.417.4,1.324,1.324,0,0,0,.648.439c.88.268,1.924-.362,2.315.245a4.106,4.106,0,0,0,.68.805,3.082,3.082,0,0,0,.417.32Z",
    transform: "translate(-1793.026 -1025.012)",
    fill: "#ffeddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M1779.25,1180.648s4.754-11.519,13.31-11.738c0,0,7.9.877,8.337,11.738Z",
    transform: "translate(-1659.235 -1078.5)",
    fill: "#ffeddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M1920.806,1155.669s3.429.763,4.486.315a1.059,1.059,0,0,0-1.284-1.233,3.029,3.029,0,0,1-2.011-.531C1921.465,1153.948,1920.667,1155.07,1920.806,1155.669Z",
    transform: "translate(-1789.828 -1064.908)",
    fill: "#db6a1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M1948.963,1117.821c-.22.165-.893-2.32-.893-2.32a2.4,2.4,0,0,1,.417.4,1.321,1.321,0,0,0,.647.439C1949.136,1116.412,1949.176,1117.66,1948.963,1117.821Z",
    transform: "translate(-1814.997 -1029.221)",
    fill: "#e5c1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M1978.219,1130.335a14.107,14.107,0,0,1-1.849.978c-.215,0,1.169-1.783,1.169-1.783A4.1,4.1,0,0,0,1978.219,1130.335Z",
    transform: "translate(-1841.087 -1042.166)",
    fill: "#e5c1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M1839.27,1217.979c-.088-.077,3.364-5.083,4.315-5.12s3.088,1.1,4.635,1.248,3.046-.292,3.338.619,1.1,4.155.6,4.673S1841.168,1219.6,1839.27,1217.979Z",
    transform: "translate(-1714.611 -1119.049)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M1344,913.344s-1.064,1.5-2.039,1.517a7.1,7.1,0,0,1-2.458-.7s-.895-1.995-.288-2.776a1.3,1.3,0,0,1,1.245.2,1.931,1.931,0,0,1,.329.315,1.049,1.049,0,0,0,.512.347c.7.211,1.522-.286,1.83.194a3.276,3.276,0,0,0,.542.637,2.436,2.436,0,0,0,.326.256Z",
    transform: "translate(-1253.036 -840.828)",
    fill: "#ffeddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M1224.34,966.462s3.759-9.108,10.524-9.281c0,0,6.246.7,6.592,9.281Z",
    transform: "translate(-1147.245 -883.146)",
    fill: "#ffeddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M1336.293,946.719s2.712.6,3.549.248a.838.838,0,0,0-1.016-.975,2.4,2.4,0,0,1-1.59-.419C1336.813,945.357,1336.181,946.244,1336.293,946.719Z",
    transform: "translate(-1250.527 -872.406)",
    fill: "#db6a1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M1358.576,916.8c-.173.13-.706-1.834-.706-1.834a1.907,1.907,0,0,1,.329.316,1.048,1.048,0,0,0,.512.347C1358.71,915.69,1358.741,916.674,1358.576,916.8Z",
    transform: "translate(-1270.447 -844.201)",
    fill: "#e5c1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M1381.668,926.677a11.21,11.21,0,0,1-1.463.773c-.17,0,.924-1.411.924-1.411A3.286,3.286,0,0,0,1381.668,926.677Z",
    transform: "translate(-1291.039 -854.415)",
    fill: "#e5c1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M1271.795,995.991c-.07-.059,2.661-4.022,3.412-4.047s2.44.867,3.663.983,2.409-.232,2.64.491.867,3.286.477,3.7S1273.3,997.273,1271.795,995.991Z",
    transform: "translate(-1191.028 -915.221)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M1100.12,1252.319s2.616,3.683,5.014,3.734,6.047-1.707,6.047-1.707,2.2-4.908.708-6.828a3.205,3.205,0,0,0-3.064.5,4.718,4.718,0,0,0-.811.773,2.572,2.572,0,0,1-1.258.851c-1.712.521-3.743-.7-4.5.478a8.05,8.05,0,0,1-1.323,1.566A6.085,6.085,0,0,1,1100.12,1252.319Z",
    transform: "translate(-1032.633 -1150.857)",
    fill: "#ffeddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M1038.776,1382.912s-9.247-22.4-25.89-22.832c0,0-15.363,1.707-16.216,22.832Z",
    transform: "translate(-937.184 -1254.884)",
    fill: "#ffeddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M1161.029,1334.334s-6.671,1.483-8.729.611a2.061,2.061,0,0,1,2.5-2.4,5.9,5.9,0,0,0,3.912-1.032C1159.752,1330.985,1161.306,1333.167,1161.029,1334.334Z",
    transform: "translate(-1080.767 -1228.453)",
    fill: "#db6a1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M1186.151,1260.751c.427.32,1.737-4.511,1.737-4.511a4.7,4.7,0,0,0-.811.773,2.575,2.575,0,0,1-1.258.851C1185.814,1258.011,1185.738,1260.439,1186.151,1260.751Z",
    transform: "translate(-1111.695 -1159.075)",
    fill: "#e5c1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M1110.6,1285.066a27.614,27.614,0,0,0,3.6,1.9c.418,0-2.274-3.469-2.274-3.469A8.052,8.052,0,0,1,1110.6,1285.066Z",
    transform: "translate(-1042.302 -1184.227)",
    fill: "#e5c1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M1121.542,1455.537c.171-.146-6.543-9.886-8.393-9.958s-6,2.134-9.012,2.419-5.924-.569-6.5,1.209-2.13,8.083-1.17,9.088S1117.85,1458.692,1121.542,1455.537Z",
    transform: "translate(-1028.983 -1333.769)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "man",
    transform: "translate(61.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M1086.163,855.31s-.211-1.04,2.184-4.243c.517-.691,2.093-3.293,2.093-3.293.623-.155,2.563.88,3.075,1.194.1.064.162.1.162.1s.83,3.6-.933,3.19c-.056-.013-.111-.023-.166-.032-1.705-.266-3.353,1.427-4.1,2.5C1087.991,855.428,1086.488,855.338,1086.163,855.31Z",
    transform: "translate(-1080.908 -782.187)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M1249.645,764.882s-.209-1.043,2.189-4.246c.517-.691,2.093-3.293,2.093-3.293.619-.155,2.563.879,3.074,1.194l.162.1s.83,3.6-.934,3.191c-.056-.013-.111-.023-.166-.033-1.705-.265-3.352,1.427-4.1,2.5C1251.473,765,1249.969,764.908,1249.645,764.882Z",
    transform: "translate(-1231.745 -698.751)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M1352.817,536.622c-.49-2.106-5.939-8.671-8.73-7.151s-1.344,9.779,1.565,19.517c.045.148.09.3.136.443a126.2,126.2,0,0,0-12.843-1.256l-.735,3.391c5.284,1.46,15.546,6.536,19.855,8.721,1.646.746,3.579.746,3.973-.7C1357.357,554.737,1352.817,536.622,1352.817,536.622Z",
    transform: "translate(-1307.928 -488.31)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M1193.957,875.5s-12.474-5.628-20.079-7.9c-.943-.282-1.808-.51-2.568-.672l.8-3.262s.746-.014,1.954-.012c4.736.014,16.594.279,18.713,2.6C1195.436,869.167,1193.957,875.5,1193.957,875.5Z",
    transform: "translate(-1159.473 -796.849)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M1548.948,1.5a4.425,4.425,0,0,1,.459,2.832,2.556,2.556,0,0,0-.232,1.274l-.671.164-.8.2s-.043-.069-.107-.186-.149-.283-.232-.476a.689.689,0,0,0-.379-.516,1.482,1.482,0,0,1-.765-.971c-.069-.4-.474-1.141-.358-1.219.281-.189.7.966.95,1.018a.252.252,0,0,0,.309-.143V3.463c.387-.944-.329-3.326.24-3.461C1547.573-.047,1548.771,1.094,1548.948,1.5Z",
    transform: "translate(-1505.036 0)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M1019.014,237.094a4.416,4.416,0,0,0,2.4,1.565,2.513,2.513,0,0,1,1.258.309l.421-.547.5-.654s-.046-.067-.127-.173-.648-.584-.659-.961a1.478,1.478,0,0,0-.579-1.093c-.337-.221-.851-.894-.971-.819-.287.179.6,1.032.548,1.279a.246.246,0,0,1-.255.223h-.006c-1.022-.026-2.912-1.647-3.263-1.18A4.5,4.5,0,0,0,1019.014,237.094Z",
    transform: "translate(-1018.268 -216.561)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M1216.868,561.265c-3.077.8-2.3,4.5-1.845,14.651.053,1.149.159,2.258.309,3.317a90.28,90.28,0,0,0-14.8-1.051,6.273,6.273,0,0,0-.533,2.231,6.427,6.427,0,0,0,1.128,3.5c7.605,2.274,19.3,6.11,19.3,6.11v-.009c.78.2,1.514-.188,2.1-1.3,2.326-4.454,6.305-34.095,6.305-34.095C1228.867,552.46,1219.944,560.467,1216.868,561.265Z",
    transform: "translate(-1185.944 -511.382)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M1340.962,271.4s1.083-2.743-1.022-6.652l2.99.664,2.032.451a19.316,19.316,0,0,1,.773,1.98c.115.339.542,1.7.671,2.118.714.03-.316,1.111-1.779,1.325A21.71,21.71,0,0,1,1340.962,271.4Z",
    transform: "translate(-1315.06 -244.273)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M1356.135,273.761a19.333,19.333,0,0,1,.773,1.98c-1.745.521-4.859-1.176-4.859-1.176a5.718,5.718,0,0,1,2.051-1.255Z",
    transform: "translate(-1326.234 -252.171)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M1315.165,193.136s-3.464,3.832-5.817,1.637-4.385-3.177-2.272-5.717,3.448-2.17,4.409-1.629S1316.006,192.083,1315.165,193.136Z",
    transform: "translate(-1283.921 -172.569)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M1289.387,162.318s.355-.393-.155-.9-1.1-1.249-.531-1.477.882.123.9-.241a1.989,1.989,0,0,1,.619-2.417c1.315-1.147,2.243-1.111,2.66-1.894s-.316-1.77-.316-1.77a1.39,1.39,0,0,1-.094.811s-.09-2.289-2.1-2.308-2.748,1.624-3.423,2.228c-1.488,1.336-2.423,2.231-2.118,3.664S1287.6,162.127,1289.387,162.318Z",
    transform: "translate(-1264.154 -140.352)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M1394.24,241.206l1.286-1.206s.523.8.155,1.151S1394.24,241.206,1394.24,241.206Z",
    transform: "translate(-1365.16 -221.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M1112.637,75.752a34.414,34.414,0,0,0-2.2-7.14l-1.8-.082s.2,4.607.155,7.829a6.827,6.827,0,0,1-.882,3.2c-.559.748-8.8,8.679-9.075,8.932l-.007.006h0c-.877.149-.78,1.59-1.681,1.832-1.5.4-4-.331-5.331.164h0s-10.7.012-12.327-.768-7.978-5.461-7.978-5.461l-1.176,1.37s4.358,8.39,7.812,9.9a65.161,65.161,0,0,0,9.384,2.541,3.783,3.783,0,0,1,2.808,2.582,43.489,43.489,0,0,1,1.577,18.866,19.885,19.885,0,0,0,6.828-.711,36.669,36.669,0,0,0,8.521-3.583c1.388-1.682.568-7.851.568-7.851a5.975,5.975,0,0,1,1.278,2.763c.232,1.245.356,1.934.433,2.371a.562.562,0,0,0,.887.354,8.158,8.158,0,0,0,2.044-1.949c1.108-2.1-1.356-10.674-4.761-16.649a3.343,3.343,0,0,1,.063-3.426c2.094-3.36,5.314-8.688,5.354-9.759A42.307,42.307,0,0,0,1112.637,75.752Z",
    transform: "translate(-1066.303 -63.23)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M1281.055,356.655s2.873,4.075.766,8.015-10.381,3.395-11.911,8.315l.928,3.064,3.459-1.874s.289-2.66,3.693-3.815c6.646-2.257,8.247-6.154,6.855-9.642a11.6,11.6,0,0,0-2.886-4.368Z",
    transform: "translate(-1250.446 -328.788)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M1348.739,331.3l3.331,1.1.164.632-4.154-.1A6.042,6.042,0,0,1,1348.739,331.3Z",
    transform: "translate(-1322.57 -305.675)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M1419.61,319.47l.111,1.722s.436.357.431.309.937-1.478.937-1.478A9.509,9.509,0,0,0,1419.61,319.47Z",
    transform: "translate(-1388.568 -294.76)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M1397.565,338.53l1.7-.573a.259.259,0,0,1,.34.214l.14,1.142a.26.26,0,0,1-.174.277l-.748.253a.259.259,0,0,1-.239-.038l-1.091-.821a.26.26,0,0,1,.073-.453Z",
    transform: "translate(-1368.066 -311.805)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M1562.66,65.42l-.15,1.431s1.805.027,1.805,0,.055-.709.055-.709l.3.793.67-.219-.767-1.294A2.8,2.8,0,0,1,1562.66,65.42Z",
    transform: "translate(-1520.415 -60.36)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M1071.536,271.9l-1.176,1.37.345,1.337.479-.329-.236-1,.824.677,1.067-1.409Z",
    transform: "translate(-1066.331 -250.87)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M1082.245,286.95a.11.11,0,1,1,.052.1.11.11,0,0,1-.052-.1Z",
    transform: "translate(-1077.296 -264.663)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M1581.53,76.047a.087.087,0,1,1,.087.087A.087.087,0,0,1,1581.53,76.047Z",
    transform: "translate(-1537.964 -70.085)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M1544.83,504.822a.232.232,0,1,1,.232.232A.232.232,0,0,1,1544.83,504.822Z",
    transform: "translate(-1504.103 -465.562)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M1521,455.092a.232.232,0,1,1,.232.232A.232.232,0,0,1,1521,455.092Z",
    transform: "translate(-1482.116 -419.679)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M1488.06,417.462a.232.232,0,1,1,.232.232A.232.232,0,0,1,1488.06,417.462Z",
    transform: "translate(-1451.724 -384.959)",
    fill: "#ebf3fa"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyPerson);
export default __webpack_public_path__ + "static/media/moneyPerson.8c6b3e56b983840adc7c58bcca086f51.svg";
export { ForwardRef as ReactComponent };